import React, { useState, useRef, useEffect, useMemo, act } from "react"
import {
  Col,
  Container,
  Row,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap"
import { ContextMenu } from "primereact/contextmenu"
import { TabView, TabPanel } from "primereact/tabview"
import { Dropdown } from "primereact/dropdown"
import { useNavigate, Link } from "react-router-dom"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import * as XLSX from "xlsx"
import jsPDF from "jspdf"
import "jspdf-autotable"
import { Dialog } from "primereact/dialog"
import Modal from "react-bootstrap/Modal"
import { Calendar } from "primereact/calendar"
import { Checkbox } from "primereact/checkbox"
import { InputTextarea } from "primereact/inputtextarea"
import { Chips } from "primereact/chips"
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
import { TreeSelect } from "primereact/treeselect"
import axios from "axios"
import { getEmployees, getEmployee, createEmployee, updateEmployee, deleteEmployee, getLookupsByName, getPrivateUsers, getCompanies, getEntityDocuments, updateEntityDocument, deleteEntityDocument, getProjects, getWorkTypes, getEntityNotes, createEntityNote, updateEntityNote, deleteEntityNote } from "../../helpers/backend-helper"
import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { TreeTable } from "primereact/treetable"
import { Sidebar } from "primereact/sidebar"
import moment from "moment"
import { MultiSelect } from "primereact/multiselect"
import { Tooltip } from "primereact/tooltip"
import { FileUpload } from "primereact/fileupload"
import { Editor } from "primereact/editor"
import { Card } from "primereact/card"
import { CascadeSelect } from "primereact/cascadeselect"
// import { Tooltip } from 'primereact/tooltip';
import { Toast } from "primereact/toast"
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import Notes from "../common-for-all/Notes"
import NotesCandidate from "../common-for-all/NotesWorkType"
import Select from "react-select"

import EmailAC from "./EmailAction"
import SubmitCandidatetoJob from "./SubmitCandidatetoJob"
import LinkContactsPopup from "pms/common-for-all/LinkContactsPopup"
import LinkContact2Popup from "pms/common-for-all/LinkContact2Popup"
import { useSelector } from "react-redux"
import TalentScan from "./TalentScan"
import ImportResume from "./ImportResumeCan"
import WorkType1 from "../common-for-all/WorkTypeOne"
import { SET_API_STATUS_FALSE, SET_API_STATUS_TRUE } from "../../store/calendar/actionTypes"
import { useDispatch } from "react-redux";
import { getCookie } from "../../helpers/cookie"
import { setPageData } from "../../store/actions"

const EmployeeAllActive = () => {

  // const { first, rows, } = useSelector(
  //   state => state.calendar.paginations
  // )
  const dispatch = useDispatch();
  const token = getCookie('access_token');
 const { first, rows } = useSelector(state => state?.calendar?.pagination)
  const [selectedWorktypes, setSelectedWorktypes] = useState([]);
  const [Notespopup, setNotespopup] = useState(false);
  const [notes, setNotes] = useState('');
  const fileUploadRef = useRef(null);
  const [selectedSmsOption, setSelectedSmsOption] = useState(null)
  const [selectedEmployee, setSelectedEmployee] = useState(null)
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const selectedSmsTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-comment mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const smsOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  // more

  const [selectedOption, setSelectedOption] = useState(null)

  const selectedOptionTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-cog mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const optionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }
  // action items

  document.title = "PMS | React Admin & Dashboard Template"

  const dt = useRef(null)

  const [smShow, setSmShow] = useState(false)

  const condidatelist = e => {
    // Set the value based on checkbox
    setcondidatevalu(e.value)
  }

  const [successAlertinter, setsuccessAlertinter] = useState(false)
  const [relocation, setRelocation] = useState(null)
  const [visibleRight, setVisibleRight] = useState(false)
  const [visibleViewRight, setVisibleViewRight] = useState(false)

  // Private functionality state
  const [privateDrop, setPrivateDrop] = useState(false);
  const [PrivetDropdown, setPrivetDropdown] = useState([]);
  // const PrivetDropdownValues = [
  //   { name: 'Mahesh', value: 'mahesh' },
  //   { name: 'Lavan', value: 'lavan' },
  //   { name: 'Vinay', value: 'vinay' },
  //   { name: 'Vasantha', value: 'vasantha' }
  // ];
  
  const [PrivetDropdownValues, setPrivetDropdownValues] = useState([]);
  const getPrivateOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.data;
        console.log(results, 'results');
        const options = results.map((category) => ({
          name: category.name
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          code: category.id,
          email: category.email,
        }));
        setPrivetDropdownValues(options);
      }
    } catch (error) {

    }
  };
  useEffect(() => {
    getPrivateOptions();
  }, []);
  {
    /* Side bar end */
  }

  const getAllActive = async (page,size,selectedCompanyid) => {
    try {
      
      const params = {
        limit: size, // Adjust for API (assuming 1-based index)
        offset: page,
        is_archived: false, 
        ...(selectedCompanyid && { company_id: selectedCompanyid }),
      };
    const response = selectedCompanyid === undefined ? await getEmployees(params) : await getEmployee({ params});
      // const response = await getEmployees(params);
      console.log("API Response:", response);
      console.log("Employee data:", response.results);

      if (response.results) {
        // Log first employee to see field structure
        if (response.results.length > 0) {
          console.log("First employee structure:", response.results[0]);
        }

        // Filter out archived employees at frontend level as well (double safety)
        const activeEmployees = response.results.filter(employee => !employee.is_archived);
        console.log(activeEmployees,'activeEmployees');
        
        // Populate the table data and total record count
        setCandidateData(activeEmployees || [])
        setTotalRecords(response.count || 0)
          dispatch(
      setPageData({
        first:first,
        rows:rows,
        totalRecords: response.count,
      })
    );
        // Transform data for interview dropdown
        const transformedData = activeEmployees.map(employee => ({
          name: employee.first_name,
          id: employee.id,
        }))
        settypeInterviewcondi(transformedData)
      } else {
        setCandidateData([])
        setTotalRecords(0)
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
      setCandidateData([])
      setTotalRecords(0)
    }
  }

  // Function to fetch companies from database
  const getCompanyData = async () => {
    try {
      console.log("Fetching companies from database...");
      const response = await getCompanies();

      if (response && response.results) {
        // Transform company data to match the expected format
        const transformedCompanies = response.results.map((company, index) => ({
          name: company.name || company.company_name,
          color: "#000000",
          id: String(company.id || `company-${index}`), // Ensure ID is always a string
          statuses: ["Pending", "Processing", "Completed"],
          // Store original company data for reference
          __original: company
        }));

        console.log("Transformed companies:", transformedCompanies);
        setModuleWorkTypes(transformedCompanies);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      // Keep the existing hardcoded companies as fallback
    }
  };

  // Function to fetch designations from database
  const getDesignationData = async () => {
    try {
      console.log("Fetching designations from database...");
      const response = await getLookupsByName("employee_designation");

      console.log("Full API response:", response);

      if (response && response.results && response.results.results) {
        // Transform designation data to match the expected format
        const transformedDesignations = response.results.results.map((designation, index) => ({
          name: designation.value || designation.name,
          color: "#000000",
          id: String(designation.id || `designation-${index}`), // Ensure ID is always a string
          statuses: ["Active", "Available", "Assigned"],
          // Store original designation data for reference
          __original: designation
        }));

        console.log("Transformed designations:", transformedDesignations);
        setDesignationWorkTypes(transformedDesignations);
      } else {
        console.warn("No designation data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
      // Keep the existing hardcoded designations as fallback
    }
  };

  // Function to fetch employee types from database
  const getEmployeeTypeData = async () => {
    try {
      console.log("Fetching employee types from database...");
      const response = await getLookupsByName("employee_employeeType");

      console.log("Full Employee Type API response:", response);

      if (response && response.results && response.results.results) {
        // Transform employee type data to match the expected format
        const transformedEmployeeTypes = response.results.results.map((employeeType, index) => ({
          name: employeeType.value || employeeType.name,
          color: "#000000",
          id: String(employeeType.id || `emp-type-${index}`), // Ensure ID is always a string
          statuses: ["Active", "Available", "Assigned"],
          // Store original employee type data for reference
          __original: employeeType
        }));

        console.log("Transformed employee types:", transformedEmployeeTypes);
        setEmployeeTypeWorkTypes(transformedEmployeeTypes);
      } else {
        console.warn("No employee type data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching employee types:", error);
      // Keep the existing hardcoded employee types as fallback
    }
  };

  // Function to fetch departments from database
  const getDepartmentData = async () => {
    try {
      console.log("Fetching departments from database...");
      const response = await getLookupsByName("employee_department");

      console.log("Full Department API response:", response);

      if (response && response.results && response.results.results) {
        // Transform department data to match the expected format
        const transformedDepartments = response.results.results.map((department, index) => ({
          name: department.value || department.name,
          color: "#000000",
          id: String(department.id || `dept-${index}`), // Ensure ID is always a string
          statuses: ["Active", "Available", "Assigned"],
          // Store original department data for reference
          __original: department
        }));

        console.log("Transformed departments:", transformedDepartments);
        setDepartmentWorkTypes(transformedDepartments);
      } else {
        console.warn("No department data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      // Keep the existing hardcoded departments as fallback
    }
  };

  // Function to fetch work locations from database
  const getWorkLocationData = async () => {
    try {
      console.log("Fetching work locations from database...");
      const response = await getLookupsByName("employee_workLocation");

      console.log("Full Work Location API response:", response);

      if (response && response.results && response.results.results) {
        // Transform work location data to match the expected format
        const transformedWorkLocations = response.results.results.map((workLocation, index) => ({
          name: workLocation.value || workLocation.name,
          color: "#000000",
          id: String(workLocation.id || `location-${index}`), // Ensure ID is always a string
          statuses: ["Active", "Available", "Assigned"],
          // Store original work location data for reference
          __original: workLocation
        }));

        console.log("Transformed work locations:", transformedWorkLocations);
        setWorkLocationWorkTypes(transformedWorkLocations);
      } else {
        console.warn("No work location data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching work locations:", error);
      // Keep the existing hardcoded work locations as fallback
    }
  };

  // Function to fetch employee status from database
  const getEmployeeStatusData = async () => {
    try {
      console.log("Fetching employee status from database...");
      const response = await getLookupsByName("employee_employeeStatus");

      console.log("Full Employee Status API response:", response);

      if (response && response.results && response.results.results) {
        // Transform employee status data to match the expected format
        const transformedEmployeeStatus = response.results.results.map((employeeStatus, index) => ({
          name: employeeStatus.value || employeeStatus.name,
          color: "#000000",
          id: String(employeeStatus.id || `emp-status-${index}`), // Ensure ID is always a string
          statuses: ["Active", "Available", "Assigned"],
          // Store original employee status data for reference
          __original: employeeStatus
        }));

        console.log("Transformed employee status:", transformedEmployeeStatus);
        setEmployeeStatusWorkTypes(transformedEmployeeStatus);
      } else {
        console.warn("No employee status data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching employee status:", error);
      // Keep the existing hardcoded employee status as fallback
    }
  };

  // Function to fetch shift timings from database
  const getShiftTimingData = async () => {
    try {
      console.log("Fetching shift timings from database...");
      const response = await getLookupsByName("employee_shiftTimings");

      console.log("Full Shift Timing API response:", response);

      if (response && response.results && response.results.results) {
        // Transform shift timing data to match the expected format
        const transformedShiftTimings = response.results.results.map((shiftTiming, index) => ({
          name: shiftTiming.value || shiftTiming.name,
          color: "#000000",
          id: String(shiftTiming.id || `shift-${index}`), // Ensure ID is always a string
          statuses: ["Active", "Available", "Assigned"],
          // Store original shift timing data for reference
          __original: shiftTiming
        }));

        console.log("Transformed shift timings:", transformedShiftTimings);
        setShiftTimingWorkTypes(transformedShiftTimings);
      } else {
        console.warn("No shift timing data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching shift timings:", error);
      // Keep the existing hardcoded shift timings as fallback
    }
  };

  // Fetch projects data from API
  const getProjectsData = async () => {
    try {
      console.log("Fetching projects from database...");
      const response = await getProjects();

      if (response && response.results) {
        // Transform project data to match the expected format
        const transformedProjects = response.results.map((project, index) => ({
          name: project.name || project.project_name,
          color: "#000000",
          id: String(project.id || `project-${index}`), // Ensure ID is always a string
          statuses: ["Pending", "Active", "Completed"],
          // Store original project data for reference
          __original: project
        }));

        console.log("Transformed projects:", transformedProjects);
        setProjectWorkTypes(transformedProjects);
      } else {
        console.warn("No projects data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      // Keep the existing hardcoded data as fallback
    }
  };

  // Fetch work types data from API
  const getWorkTypesData = async () => {
    try {
      console.log("Fetching work types from database...");
      const response = await getLookupsByName("employee_workTypes");

      if (response && response.results) {
        // Transform work type data to match the expected format
        const transformedWorkTypes = response.results.results.map((workType, index) => ({
          name: workType.value || workType.work_type_name,
          color: "#000000",
          id: String(workType.id || `worktype-${index}`), // Ensure ID is always a string
          statuses: ["Pending", "Active", "Inactive"],
          // Store original work type data for reference
          __original: workType
        }));

        console.log("Transformed work types:", transformedWorkTypes);
        setActualWorkTypes(transformedWorkTypes);
      } else {
        console.warn("No work types data found in API response:", response);
      }
    } catch (error) {
      console.error("Error fetching work types:", error);
      // Keep the existing hardcoded data as fallback
    }
  };

  // Fetch employee-specific projects data
  const getEmployeeProjectsData = async (id) => {
    try {
      const response = await getProjects({employee_id: id});

      if (response && response.results) {
        const employeeProjects = response.results.map((project, index) => ({
          key: project?.id ?? index,
          data: {
            project_code: project?.code,
            project_name: project?.name,
            summary: project?.description ?? project?.summary,
            project_manager: project?.project_manager_name,
            delivery_manager: project?.delivery_manager_name,
            assigned_to: project?.assigned_to,
            status: project?.project_status_name,
            start_date: project?.start_date ? new Date(project.start_date).toLocaleDateString() : undefined,
            end_date: project?.end_date ? new Date(project.end_date).toLocaleDateString() : undefined,
            company_name: project?.company_name,
            team_size: project?.team_size,
            project_duration_days: project?.project_duration_days,
            reason_for_delay: project?.reason_for_delay,
            created_at: project?.created_at ? new Date(project.created_at).toLocaleDateString() : undefined,
            // Store original data
            __original: project
          }
        }));

        console.log("Transformed employee projects:", employeeProjects);
        return employeeProjects;
      } else {
        console.warn("No projects data found in API response:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching employee projects:", error);
      // Return empty array on error
      return [];
    }
  };

  // Fetch employee-specific work types data
  const getEmployeeWorkTypesData = async (employeeId) => {
    try {
      console.log("Fetching employee work types for ID:", employeeId);

      // Get work types for the specific employee
      const params = {
        employee: employeeId // Filter work types by employee ID
      };
      const response = await getWorkTypes(params);

      if (response && response.results) {
        // Transform work type data to match the expected table format
        const employeeWorkTypes = response.results.map((workType, index) => ({
          task_code: workType.code || `WT-${workType.id}`,
          task_type: workType.name || workType.work_type_name || 'Unnamed Work Type',
          project_name: workType.project_name || 'Not Assigned',
          project_code: workType.project_code || '',
          task_name: workType.description || workType.summary || 'No description available',
          assigned_to: workType.assigned_to_employee_name || 'Not Assigned',
          task_status: workType.work_type_status_name || workType.work_type_status || 'Active',
          // Store original data for reference
          __original: workType
        }));

        console.log("Transformed employee work types:", employeeWorkTypes);
        return employeeWorkTypes;
      } else {
        console.warn("No work types data found in API response:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching employee work types:", error);
      // Return empty array on error
      return [];
    }
  };

  useEffect(() => {
    getAllActive(first, rows)
    getcategoriesitem()
    getgroupsitem()
    getCompanyData() // Fetch companies from database
    getDesignationData() // Fetch designations from database
    getEmployeeTypeData() // Fetch employee types from database
    getDepartmentData() // Fetch departments from database
    getWorkLocationData() // Fetch work locations from database
    getEmployeeStatusData() // Fetch employee status from database
    getShiftTimingData() // Fetch shift timings from database
    getProjectsData() // Fetch projects from database
    getWorkTypesData() // Fetch work types from database
  }, [first, rows])
  const [deleteRowId, setDeleteRowID] = useState(null) // end date value
  const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false) // bulk delete confirmation modal
  const [lastSelectedLookupId, setLastSelectedLookupId] = useState(null);
  const [lookupDescription, setLookupDescription] = useState('')
  const [selectedEditdrop, setSelectedEditdrop] = useState(null)
  const [selecteddropoptions, setselecteddropoptions] = useState([])
  const [lookupModalVisible, setLookupModalVisible] = useState(false);
  const [lookupModalContext, setLookupModalContext] = useState(null); // 'designation' | 'department' | 'category' | 'group'
  const [lookupFormValue, setLookupFormValue] = useState('');
  const [editingLookup, setEditingLookup] = useState(false);
  const lookupAddSentinel = { id: "add", value: "Add New", name: "Add New", label: "Add New", icon: "pi pi-plus" };
  const lookupEditSentinel = { id: "edit", value: "Edit Selected", name: "Edit Selected", label: "Edit Selected", icon: "pi pi-pencil" };

  const lookupItemTemplate = (option) => {
    if (!option) return null;
    return (
      <div className="flex align-items-center gap-2">
        {option.icon && <i className={option.icon} />}
        <span style={option.id === 'add' || option.id === 'edit' ? { fontStyle: 'italic' } : {}}>{option.label || option.name || option.value}</span>
      </div>
    );
  }
  const textEditor = options => {
    return (
      <InputText
        value={options.value}
        onChange={e => options.editorCallback(e.target.value)}
      />
    )
  }

  const [categoriesitem, setcategoriesitem] = useState([])
  const [groupitem, setgroupitem] = useState([])

  const [HaveImagePan, setHaveImagePan] = useState(false)
  const [PoliciesfilesErrorMessagepan, setPoliciesfilesErrorMessagepan] =
    useState()

  const [selectedNodeKey, setSelectedNodeKey] = useState(null)
  const [selectedgroupKey, setselectedgroupKey] = useState(null)
  // Function to convert flat data to hierarchical structure
  const buildTree = data => {
    const map = {}
    const tree = []

    data.forEach(item => {
      map[item.category_id] = {
        ...item,
        key: item.category_id,
        label: item.name,
        children: [],
      }
    })

    data.forEach(item => {
      if (item.parent_category) {
        if (map[item.parent_category]) {
          map[item.parent_category].children.push(map[item.category_id])
        }
      } else {
        tree.push(map[item.category_id])
      }
    })

    return tree
  }

  const getcategoriesitem = async () => {
    try {
      const response = await getLookupsByName("employee_categories");

      if (response.results && response.results.results) {
        // Convert flat lookup data to tree structure for TreeSelect
        const treeData = response.results.results.map(item => ({
          key: item.id.toString(),
          label: item.value,
          category_id: item.id,
          data: item
        }));
        setcategoriesitem(treeData)
        console.log("Employee categories loaded:", treeData);
      }
    } catch (error) {
      console.error("Error fetching employee categories:", error);
      // Fallback to empty array on error
      setcategoriesitem([]);
    }
  }

  const onSubmit = async data => {
    // Extract company ID from selected company - try multiple paths
    let companyId = null;

    if (selectedModule) {
      // Try to get the original numeric ID from the database
      companyId = selectedModule.__original?.id || selectedModule.id;

      // Convert to number if it's a stringified number
      if (typeof companyId === 'string' && !isNaN(companyId) && !companyId.startsWith('custom-')) {
        companyId = parseInt(companyId, 10);
      }
    }

    // Validate company selection
    if (!companyId || companyId === 'divider' || String(companyId).startsWith('create-new-') || String(companyId).startsWith('edit-selected-') || String(companyId).startsWith('custom-')) {
      alert('Please select a valid company');
      return;
    }

    const employeeData = {
      first_name: data.firstname,
      last_name: data.lastname,
      designation: data.Designation,
      primary_email: data.personal_email,
      personal_phone: data.phone,
      categories: extractCategoryId(selectedNodeKey, categoriesitem),
      groups: extractGroupId(selectedgroupKey, groupitem),
      company: companyId, // Send company ID instead of company_name
      date_of_joining: data.Availability,
      primary_skills: primarySkills,
      // Note: File uploads may need special handling - for now excluding resume
    };

    console.log("Employee data payload:", employeeData); // Debug log
    console.log("Selected company:", selectedModule); // Debug log
    console.log("Extracted category ID:", extractCategoryId(selectedNodeKey, categoriesitem)); // Debug log
    console.log("Extracted group ID:", extractGroupId(selectedgroupKey, groupitem)); // Debug log

    try {
      const response = await createEmployee(employeeData);
      getAllActive(first, rows)
      setVisibleRight(false)
    } catch (error) {
      console.error("Error creating employee:", error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create employee';
      alert(`Error: ${errorMessage}`);
    }
  }
  const onSubmitinterview = async data => {
    let req = {}

    if (!subtype) {
      alert("select type")
      return false
    }
    if (!subjectval) {
      alert("select type subjectval")
      return false
    }
    if (subtype) {
      req.event_sub_type = subtype
    }

    if (intertype) {
      req.event_type = intertype
    }

    if (enddate) {
      req.end_date = moment(enddate).format("YYYY-MM-DD")
    }
    if (startdate) {
      req.start_date = moment(startdate).format("YYYY-MM-DD")
    }
    if (starttime) {
      req.start_time = moment(starttime).format("HH:mm:ss")
    }
    if (endtime) {
      req.end_time = moment(endtime).format("HH:mm:ss")
    }
    // if (condidatevalu) {
    //   req.candidate_id = condidatevalu.id;
    // }
    if (condidatevalu && condidatevalu.length > 0) {
      req.candidate_ids = condidatevalu.map(candidate => candidate.email)
    } else {
      alert("Please select at least one candidate")
      return false
    }
    if (subjectval) {
      req.subject = subjectval
    }
    if (prioritycontact) {
      req.contact_id = prioritycontact.id
    }
    if (subtypeget) {
      req.job_id = subtypeget.id
    }
    if (repeat) {
      req.repeat = repeat
    }
    if (followup) {
      req.auto_followup = followup
    }
    if (reminder) {
      req.reminder = reminder
    }

    req.event_time = "2024-12-03T00:30:00Z"

    req.created_by = 1
    req.event_priority = "High"

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Calendar}/api/v1/events/`,
        req,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      SetInterviewpop(false)

      setsuccessAlertinter(true)
      setSelectedCustomers([])
      setselectedEmployees(0)
    } catch (error) { }
  }

  const deleteHandler = async () => {
    try {
      let id = deleteRowId;
      await deleteEmployee(id);
      setSmShow(false);
      getAllActive(first, rows);
      setSuccessAlert(true);
    } catch (error) {
      console.error("Error deleting employee:", error);
      setSmShow(false);
    }
  }

  // Handle bulk delete - show confirmation modal
  const handleBulkDelete = () => {
    setShowBulkDeleteConfirm(true);
  }
  const handleArchived = () => {
    if (selectedCustomers && selectedCustomers.length > 0) {
      selectedCustomers.forEach(async (element) => {
        // Call the archive API for each selected employee
        try {
         const response = await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/employees/${element.id}/`, { is_archived: true }, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            toast.current.show({ severity: 'success', summary: 'Success', detail: `Employee archived successfully` });
            getAllActive(first, rows);
            setSelectedCustomers([]);
          }
          console.log(`Archived employee with ID: ${element.id}`);
        } catch (error) {
          console.error(`Error archiving employee ${element.id}:`, error);
        }
      });
    }
  }

  // Confirm bulk delete - actually delete selected employees
  const confirmBulkDelete = async () => {
    try {
      setLoading(true);
      console.log('Selected employees for deletion:', selectedCustomers);

      // Delete all selected employees
      const deleteResults = [];
      for (const employee of selectedCustomers) {
        console.log(`Attempting to delete employee with ID: ${employee.id}`);
        try {
          const result = await deleteEmployee(employee.id);
          console.log(`Delete result for employee ${employee.id}:`, result);
          deleteResults.push({ id: employee.id, success: true });
        } catch (error) {
          console.error(`Error deleting employee ${employee.id}:`, error);
          deleteResults.push({ id: employee.id, success: false, error });
        }
      }

      const successCount = deleteResults.filter(r => r.success).length;
      const failCount = deleteResults.filter(r => !r.success).length;

      if (successCount > 0) {
        // Show success message
        toast.current.show({
          severity: successCount === selectedCustomers.length ? 'success' : 'warn',
          summary: successCount === selectedCustomers.length ? 'Success' : 'Partial Success',
          detail: `Successfully deleted ${successCount} employee(s)${failCount > 0 ? `, ${failCount} failed` : ''}`
        });

        // Clear selection and refresh the list to exclude archived employees
        setSelectedCustomers([]);
        getAllActive(first, rows);
      } else {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete any employees'
        });
      }

    } catch (error) {
      console.error("Error in bulk delete:", error);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'An error occurred during bulk deletion'
      });
    } finally {
      setLoading(false);
      setShowBulkDeleteConfirm(false);
    }
  }

  const getCandidateIds = () => {
    const selectedIds = selectedCustomers.map(
      candidate => candidate.candidate_id
    )
    setDeleteRowID(selectedIds)
    setSmShow(true)
  }

  const buildTreegroup = data => {
    const map = {}
    const tree = []

    data.forEach(item => {
      map[item.group_id] = {
        ...item,
        key: item.group_id,
        label: item.name,
        children: [],
      }
    })

    data.forEach(item => {
      if (item.parent_groups) {
        if (map[item.parent_groups]) {
          map[item.parent_groups].children.push(map[item.group_id])
        }
      } else {
        tree.push(map[item.group_id])
      }
    })

    return tree
  }

  // Helper function to extract category ID from tree selection
  const extractCategoryId = (selectedKey, treeData) => {
    if (!selectedKey || !treeData) return null;

    // If selectedKey is already a number, return it
    if (typeof selectedKey === 'number') return selectedKey;

    // If selectedKey is a simple string number, parse and return it
    if (typeof selectedKey === 'string' && !selectedKey.includes('-')) {
      const parsed = parseInt(selectedKey);
      if (!isNaN(parsed)) return parsed;
    }

    // For flat structure, find the item directly by key
    const flatItem = treeData.find(item => item.key === selectedKey);
    if (flatItem && flatItem.category_id) {
      return flatItem.category_id;
    }

    // For TreeSelect composite keys like "0-0-0", find the actual node (legacy support)
    const findNodeByPath = (nodes, keyPath) => {
      const pathParts = keyPath.split('-').map(p => parseInt(p));
      let currentNode = nodes[pathParts[0]];

      for (let i = 1; i < pathParts.length; i++) {
        if (currentNode?.children) {
          currentNode = currentNode.children[pathParts[i]];
        } else {
          break;
        }
      }

      return currentNode;
    };

    const node = findNodeByPath(treeData, selectedKey);
    return node?.category_id || null;
  };

  // Helper function to extract group ID from tree selection
  const extractGroupId = (selectedKey, treeData) => {
    if (!selectedKey || !treeData) return null;

    // If selectedKey is already a number, return it
    if (typeof selectedKey === 'number') return selectedKey;

    // If selectedKey is a simple string number, parse and return it
    if (typeof selectedKey === 'string' && !selectedKey.includes('-')) {
      const parsed = parseInt(selectedKey);
      if (!isNaN(parsed)) return parsed;
    }

    // For flat structure, find the item directly by key
    const flatItem = treeData.find(item => item.key === selectedKey);
    if (flatItem && flatItem.group_id) {
      return flatItem.group_id;
    }

    // For TreeSelect composite keys like "0-1-0", find the actual node (legacy support)
    const findNodeByPath = (nodes, keyPath) => {
      const pathParts = keyPath.split('-').map(p => parseInt(p));
      let currentNode = nodes[pathParts[0]];

      for (let i = 1; i < pathParts.length; i++) {
        if (currentNode?.children) {
          currentNode = currentNode.children[pathParts[i]];
        } else {
          break;
        }
      }

      return currentNode;
    };

    const node = findNodeByPath(treeData, selectedKey);
    return node?.group_id || null;
  };

  const getgroupsitem = async () => {
    try {
      const response = await getLookupsByName("employee_group");

      if (response.results && response.results.results) {
        // Convert flat lookup data to tree structure for TreeSelect
        const treeData = response.results.results.map(item => ({
          key: item.id.toString(),
          label: item.value,
          group_id: item.id,
          data: item
        }));
        setgroupitem(treeData);
        console.log("Employee groups loaded:", treeData);
      }
    } catch (error) {
      console.error("Error fetching employee groups:", error);
      // Fallback to empty array on error
      setgroupitem([]);
    }
  }
  const [selectedRow, setSelectedRow] = useState(null)
  const contextMenu = useRef(null)
  const editRow = rowData => {
    alert(`Edit: ${rowData.name}`)
  }

  const deleteRow = rowData => {
    setData(data.filter(row => row.id !== rowData.id))
    alert(`Deleted: ${rowData.name}`)
  }

  const viewRowDetails = rowData => {
    alert(`Details of: ${rowData.name}`)
  }
  const menuItems = [
    {
      label: "Edit",
      icon: "pi pi-pencil",
      command: () => editRow(selectedRow),
    },
    {
      label: "Delete",
      icon: "pi pi-trash",
      command: () => deleteRow(selectedRow),
    },
    {
      label: "View Details",
      icon: "pi pi-search",
      command: () => viewRowDetails(selectedRow),
    },
  ]

  // const [selectedCity, setSelectedCity] = useState(null)

  const [primarySkills, setPrimarySkills] = useState(null)

  // interview

  const [primarySkillsvalu, setprimarySkillsvalu] = useState([])
  const getprimary = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CONDIDATES}/api/v1/skills/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (response.data && response.data.results) {
        const treeData = response.data.results

        setprimarySkillsvalu(treeData)
      }
    } catch (error) { }
  }

  const [city, setCity] = useState("")
  const [fullName, setFullName] = useState("")
  const [Designation, setDesignation] = useState("")
  const [company, setCompany] = useState("")
  const [userIds, setUserIds] = useState("")
  const [availabilityDate1, setavailabilityDate1] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [workEmail, setWorkEmail] = useState("")
  const [editingRow, setEditingRow] = useState(null);
  const [editedValue, setEditedValue] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);
  const [currentEmployeeId, setCurrentEmployeeId] = useState(null);

  // Save the edited data
  const handleSave = async () => {
    if (!currentEmployeeId || !editingRow) return;

    try {
      console.log('Updating document:', editingRow, editedValue);

      // Call the update document API
      await updateEntityDocument('employees', currentEmployeeId, editingRow, {
        name: editedValue.docSubject,
        type: editedValue.certificate_name,
        description: editedValue.docSubject
      });

      setEditingRow(null);

      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Document updated successfully'
      });

    } catch (error) {
      console.error('Error updating document:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to update document'
      });
    }
  };

  // Cancel editing
  const handleCancel = () => {
    setEditingRow(null);
    setEditedValue({});
  };


  // Actual delete function
  const deleteDocument = async (rowKey) => {
    if (!currentEmployeeId) return;

    try {
      console.log('Deleting document:', rowKey);

      // Call the delete document API
      await deleteEntityDocument('employees', currentEmployeeId, rowKey);

      // Update local state
      // setDocuments((prevDocuments) => prevDocuments.filter((doc) => doc.key !== rowKey));

      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Document deleted successfully'
      });

    } catch (error) {
      console.error('Error deleting document:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to delete document'
      });
    }
  };

  // Date formatting template
  const dateTemplate = (rowData, field) => {
    if (!rowData.data[field]) return '';

    try {
      const date = new Date(rowData.data[field]);
      if (isNaN(date.getTime())) return rowData.data[field];

      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (error) {
      return rowData.data[field];
    }
  };

  // Editable input field
  const editableTemplate = (rowData, field) => {
    // Make created_at non-editable
    if (field === 'created_at') {
      return <span>{dateTemplate(rowData, field)}</span>;
    }

    return editingRow === rowData.key ? (
      <InputText
        value={editedValue[field] || ""}
        onChange={(e) => setEditedValue({ ...editedValue, [field]: e.target.value })}
        autoFocus={field === 'certificate_name'} // Auto focus on first field
      />
    ) : (
      <span onClick={() => handleEdit(rowData.key)} className="cursor-pointer" title="Click to edit">
        {rowData.data[field]}
      </span>
    );
  };

  // Action buttons
  const actionTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        {editingRow === rowData.key ? (
          <>
            <Button icon="pi pi-check" rounded outlined className="document-btn" onClick={handleSave} />
            <Button icon="pi pi-times" rounded outlined className="document-btn" onClick={handleCancel} />
          </>
        ) : (
          <>
            <Button icon="pi pi-pencil" rounded outlined className="document-btn" onClick={() => handleEdit(rowData.key)} tooltip="Edit Document" />
            {rowData.data.file_url && (
              <Button
                icon="pi pi-download"
                rounded
                outlined
                className="document-btn"
                onClick={() => handleDownload(rowData.data.file_url, rowData.data.docSubject)}
                tooltip="Download Document"
              />
            )}
          </>
        )}
        <Button icon="pi pi-trash" rounded outlined className="document-btn" onClick={() => handleDelete(rowData.key)} tooltip="Delete Document" />
      </div>
    );
  };

  // Handle document download
  const handleDownload = (fileUrl, fileName) => {
    if (!fileUrl) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Download URL not available for this document'
      });
      return;
    }

    try {
      // Create a temporary link element and trigger download
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName || 'document';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log('Download initiated for:', fileName);
    } catch (error) {
      console.error('Error downloading document:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to download document'
      });
    }
  };


  const [description, setDescription] = useState("")

  const geteditvaluescondidates = async candidate_id => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CONDIDATES}/api/v1/candidates/${candidate_id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (response.data) {
        let results = response.data

        setTimeout(() => {
          setFullName(
            results.first_name,
            results.middle_name,
            results.last_name
          )
          // Map designation id to display name when possible
          let mappedEditDesignation = results.designation || '';
          if (mappedEditDesignation && designationWorkTypes && designationWorkTypes.length > 0) {
            const foundEdit = designationWorkTypes.find(d => String(d.id) === String(mappedEditDesignation) || String(d.id) === String(mappedEditDesignation?.id));
            if (foundEdit) mappedEditDesignation = foundEdit.name;
          }
          setDesignation(mappedEditDesignation)

          // Map project id to display name when possible
          let mappedEditProject = results.project || results.project_id || '';
          if (mappedEditProject && projectWorkTypes && projectWorkTypes.length > 0) {
            const foundEditProject = projectWorkTypes.find(p => String(p.id) === String(mappedEditProject) || String(p.id) === String(mappedEditProject?.id));
            if (foundEditProject) mappedEditProject = foundEditProject.name;
          }
          setSelectedProject(mappedEditProject)

          // Map work type id to display name when possible
          let mappedEditWorkType = results.work_type || results.worktype || results.work_type_id || '';
          if (mappedEditWorkType && actualWorkTypes && actualWorkTypes.length > 0) {
            const foundEditWorkType = actualWorkTypes.find(w => String(w.id) === String(mappedEditWorkType) || String(w.id) === String(mappedEditWorkType?.id));
            if (foundEditWorkType) mappedEditWorkType = foundEditWorkType.name;
          }
          setSelectedWorkType(mappedEditWorkType)

          setCompany(results.current_company)
          setPhoneNumber(results.mobile_phone)
          setWorkEmail(results.email)
          setavailabilityDate1(results.availability_date)
          setCity(results.city)
          setSelectedNodeKey(results.categories)
          setselectedgroupKey(results.groups)
          setPrimarySkills(results.primary_skills)
          setDescription(results.description)
        }, 1000)
      }
    } catch (error) { }
  }

  
const getDocuments = async (id) => {
    try {
      const id = selectedCustomers[0]?.id
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/employees/${id}/documents/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const apiData = response.data.data;

        setDocuments(apiData);
      }
    } catch (err) {
      console.log(err);

    }
  }
  useEffect(() => {
    if (selectedCustomers) {
      getDocuments();
    }
  }, [selectedCustomers]);




  const getjobs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Jobs}/api/v1/jobs/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      // Transform data if needed to match the Dropdown format
      const transformedData = response.data.results.map(city => ({
        name: city.designation,
        id: city.job_id,
      }))
      settypeInterviewval(transformedData)
    } catch (error) { }
  }

  const getallactivecontacts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/api/v1/contacts/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const transformedData = response.data.results.map(city => ({
        name: city.first_name,
        id: city.contact_id,
      }))
      settypeInterviewcontact(transformedData)
    } catch (error) { }
  }
  const [interviewdroptype, setinterviewdroptype] = useState([])

  const getallinterviewdrop = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Calendar}/api/v1/event-lookup/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const data = response.data
      const types = data.Types.map(type => ({
        label: type,
      }))
      if (response.data === 500) {
        console.log(response)
      }

      setinterviewdroptype(types)
    } catch (error) { }
  }

  useEffect(() => {
    getjobs()
    getallactivecontacts()
    getallinterviewdrop()
  }, [])

  const getSelectedCount = () => {
    alert(`Selected Candidates: ${selectedCustomers.length}`)
  }

  // datatable

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Firstname: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Lastname: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Designation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    MobilePhone: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Yearsofexperience: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    City: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    AvailabilityDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Relocation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Categories: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    Groups: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    ResumeAttachment: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    PrimarySkills: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    CreatedBy: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    EditDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    CreateDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [loading, setLoading] = useState(false)
  const [globalFilterValue, setGlobalFilterValue] = useState("")

    
  const [balanceFrozen, setBalanceFrozen] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [size, setSize] = useState("normal")
  const [totalRecords, setTotalRecords] = useState(0)

  const [candidateData, setCandidateData] = useState([]);
  const [customers, setCustomers] = useState([])
  // useEffect(() => {
  //     setCustomers(sampleData);
  // }, []);
  const onGlobalFilterChange = e => {
    const value = e.target.value
    let _filters = { ...filters }
    _filters["global"].value = value
    setFilters(_filters)
    setGlobalFilterValue(value)
  }
  const onSelectionChange = e => {
    console.log('Selection changed:', e.value);
    console.log('Selected employee structure:', e.value.length > 0 ? e.value[0] : 'No selection');
    setSelectedCustomers(e.value)
    setSelectedEmployee(e.value[0]?.id || '')
  }
  const onPage = e => {
    setPageState({
      first: e.first,
      rows: e.rows,
      totalRecords:totalRecords
    })
  }
  const onRowReorder = e => {
    setCustomers(e.value)
  }

  // context menu starts
  const [selectedCandidate, setSelectedCandidate] = useState(null); // State to track the right-clicked candidate

  const cm = useRef(null); // Reference for ContextMenu

  // Context menu options
  const menuModel = [
    { label: 'View', icon: 'pi pi-fw pi-eye', command: () => handleViewSelected(selectedCandidate) },
    { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => navigate(`/employee-edit?id=${selectedCandidate?.id}`) },
    { label: 'Archive', icon: 'pi pi-check-circle' },
    { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => deleteCandidate(selectedCandidate) },

    {
      label: 'Schedule', icon: 'pi pi-calendar-clock',
      items: [ // Subitems for "Schedule"
        { label: 'Interview', icon: 'pi pi-calendar-plus' },
        { label: 'Call', icon: 'pi pi-phone' },
        { label: 'Meeting', icon: 'pi pi-users' },
        { label: 'Task', icon: 'pi pi-list' },
        { label: 'Event', icon: 'pi pi-calendar-clock' },
        { label: 'Other', icon: 'pi pi-ellipsis-h' },
      ],
    },

  ];

  // Function to handle viewing a candidate
  const viewCandidate = (candidate) => {
    toast.current.show({ severity: 'info', summary: 'Candidate Selected', detail: `${candidate.Firstname} ${candidate.Lastname}` });
  };

  // Fetch employee details from backend and populate view sidebar
  const handleViewSelected = async (candidateParam) => {
    // Allow explicit candidate param (from header button or context menu) or fall back to selectedCandidate
    const candidateToView = candidateParam || selectedCandidate;

    if (!candidateToView || !candidateToView.id) {
      toast.current.show({ severity: 'warn', summary: 'No Selection', detail: 'No employee selected to view' });
      return;
    }

    try {
      const res = await getEmployee(candidateToView.id);
      const emp = res || {};

      // Populate view fields (map backend fields to local state)
      setFullName([emp.first_name, emp.middle_name, emp.last_name].filter(Boolean).join(' '));
      // Map designation id to display name if needed
      let mappedDesignation = emp.designation || emp.job_title || '';
      if (mappedDesignation && designationWorkTypes && designationWorkTypes.length > 0) {
        const found = designationWorkTypes.find(d => String(d.id) === String(mappedDesignation) || String(d.id) === String(mappedDesignation?.id));
        if (found) mappedDesignation = found.name;
      }
      setDesignation(mappedDesignation);
      setCompany(emp.company_name || emp.company || '');
      setPhoneNumber(emp.personal_phone || emp.mobile_phone || '');
      setWorkEmail(emp.primary_email || emp.email || '');
      setavailabilityDate1(emp.date_of_joining || emp.availability_date || '');
      setSelectedNodeKey(emp.categories || null);
      setselectedgroupKey(emp.groups || null);

      // Map project and worktype
      let mappedProject = emp.project || emp.project_id || '';
      if (mappedProject && projectWorkTypes && projectWorkTypes.length > 0) {
        const foundProject = projectWorkTypes.find(p => String(p.id) === String(mappedProject) || String(p.id) === String(mappedProject?.id));
        if (foundProject) mappedProject = foundProject.name;
      }
      setSelectedProject(mappedProject);

      let mappedWorkType = emp.work_type || emp.worktype || emp.work_type_id || '';
      if (mappedWorkType && actualWorkTypes && actualWorkTypes.length > 0) {
        const foundWorkType = actualWorkTypes.find(w => String(w.id) === String(mappedWorkType) || String(w.id) === String(mappedWorkType?.id));
        if (foundWorkType) mappedWorkType = foundWorkType.name;
      }
      setSelectedWorkType(mappedWorkType);

      setPrimarySkills(emp.primary_skills || emp.primary_skills || []);
      setDescription(emp.description || emp.notes || '');

      // Clear previous documents before loading new ones
      // setDocuments([]);
      setIsLoadingDocuments(false);

      // Set current employee ID for document operations
      setCurrentEmployeeId(emp.id);


      // Load employee projects data for the Projects tab
      if (emp.id) {
        try {
          setIsLoadingProjects(true);
          const employeeProjectsData = await getEmployeeProjectsData(emp.id);
          setCompanyProjects(employeeProjectsData);
          console.log('Successfully loaded employee projects');
        } catch (e) {
          console.error('Failed to load employee projects:', e);
          // Set empty array on error
          setCompanyProjects([]);
        } finally {
          setIsLoadingProjects(false);
        }
      }

      // Load employee work types data for the WorkType tab
      if (emp.id) {
        try {
          const employeeWorkTypesData = await getEmployeeWorkTypesData(emp.id);
          setWorktypeData(employeeWorkTypesData);
          console.log('Successfully loaded employee work types');
        } catch (e) {
          console.error('Failed to load employee work types:', e);
          // Set empty array on error
          setWorktypeData([]);
        }
      }

      // Set current employee ID for notes operations
      setCurrentEmployeeId(emp.id);

      // Load employee notes
      if (emp.id) {
        try {
          await loadEmployeeNotes(emp.id);
        } catch (e) {
          console.error('Failed to load employee notes:', e);
        }
      }

      // Also ensure the selectedCandidate state reflects this viewed candidate
      setSelectedCandidate(candidateToView);
      setVisibleViewRight(true);
    } catch (error) {
      console.error('Error fetching employee details:', error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to load employee details' });
    }
  };

  // Function to handle editing a candidate
  const editCandidate = (candidate) => {
    toast.current.show({ severity: 'success', summary: 'Edit Candidate', detail: `Editing ${candidate.Firstname} ${candidate.Lastname}` });
    // Add your edit logic here
  };

  // Function to handle deleting a candidate
  const deleteCandidate = async (candidate) => {
    if (!candidate || !candidate.id) {
      toast.current.show({ severity: 'warn', summary: 'No Selection', detail: 'No employee selected to delete' });
      return;
    }

    try {
      await deleteEmployee(candidate.id);
      let _candidates = [...candidateData];
      _candidates = _candidates.filter((c) => c.id !== candidate.id);
      setCandidateData(_candidates);
      toast.current.show({ severity: 'success', summary: 'Deleted', detail: `Deleted ${candidate.Firstname} ${candidate.Lastname}` });
      // refresh list
      getAllActive(first, rows);
    } catch (error) {
      console.error('Delete employee error:', error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete employee' });
    }
  };

  // context menu ends

  const exportCSV = () => {
    if (dt.current) {
      dt.current.exportCSV()
    }
  }
  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(customers)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers")
    XLSX.writeFile(workbook, "customers_data.xlsx")
  }
  const exportPdf = () => {
    const doc = new jsPDF()
    doc.text("Customer Data", 14, 10)
    doc.autoTable({
      head: [
        [
          "ID",
          "First Name",
          "Last Name",
          "Job Title",
          "Email",
          "Phone",
          "Company",
          "Experience",
          "City",
          "Status",
          "Relocation",
          "Categories",
          "Groups",
          "ResumeAttachment",
          "PrimarySkills",
          "CreatedBy",
          "EditDate",
          "CreateDate",
        ],
      ],
      body: customers.map(customer => [
        customer.id,
        customer.Firstname,
        customer.Lastname,
        customer.Designation,
        customer.Email,
        customer.MobPhone,
        customer.Company,
        customer.Yearsofexperience,
        customer.City,
        customer.Status,
        customer.Relocation,
        customer.Categories,
        customer.Groups,
      ]),
    })
    doc.save("customers_data.pdf")
  }
  const sizeOptions = [
    { label: "Small", value: "small" },
    { label: "Normal", value: "normal" },
    { label: "Large", value: "large" },
  ]

  const uniqueStatus = [
    { name: "Active", value: "Active" },
    { name: "Inactive", value: "Inactive" },
    { name: "Pending", value: "Pending" },
    { name: "Completed", value: "Completed" }
  ]
  const uniqueCategories = [
    { name: "Frontend", value: "Frontend" },
    { name: "SEO", value: "SEO" },
    { name: "Content Writing", value: "Content Writing" },
    { name: "AI ML", value: "AI ML" }
  ]
  const filteredGroups = [
    { name: "React", value: "React" },
    { name: "Blog Writing", value: "Blog Writing" },
    { name: "Machine Learning", value: "Machine Learning" },
    { name: "On Page SEO", value: "On Page SEO" }
  ]

  const statusofdrop = options => (
    <Dropdown
      value={options.value}
      options={uniqueStatus}
      onChange={e => {
        setSelectedCategory(e.value)
        options.filterApplyCallback(e.value)
      }}
      optionLabel="name"
      placeholder="Select"
      className="p-column-filter bgclr"
      maxSelectedLabels={1}
      style={{ minWidth: "14rem" }}
    />
  )
  const representativeRowFilterTemplate = options => (
    <Dropdown
      value={options.value}
      options={uniqueCategories}
      onChange={e => {
        setSelectedCategory(e.value)
        options.filterApplyCallback(e.value)
      }}
      optionLabel="name"
      placeholder="Select"
      className="p-column-filter bgclr"
      maxSelectedLabels={1}
      style={{ minWidth: "14rem" }}
    />
  )
  const representativeRowFilterTemplate1 = options => (
    <Dropdown
      value={options.value}
      options={filteredGroups}
      onChange={e => options.filterApplyCallback(e.value)}
      optionLabel="name"
      placeholder="Select"
      className="p-column-filter bgclr"
      maxSelectedLabels={1}
      style={{ minWidth: "14rem" }}
    />
  )
  const [visibleColumns, setVisibleColumns] = useState([
    // State for visible columns
    // 'Yearsofexperience',
    // 'City',
    // 'Status',
    // 'Relocation',
    // 'Categories',
    // 'Groups',
  ])
  const firstnameEditor = props => {
    return (
      <InputText
        value={props.value}
        onChange={e => props.editorCallback(e.target.value)}
      />
    )
  }
  const firstnameEditor1 = props => {
    return (
      <InputText
        value={props.value}
        onChange={e => props.editorCallback(e.target.value)}
      />
    )
  }
  const firstnameEditor2 = props => {
    return (
      <InputText
        value={props.value}
        onChange={e => props.editorCallback(e.target.value)}
      />
    )
  }
  const firstnameEditor4 = props => {
    return (
      <InputText
        value={props.value}
        onChange={e => props.editorCallback(e.target.value)}
      />
    )
  }
  const onCellEditComplete = e => {
    const { rowData, newValue, field } = e
    if (rowData[field] !== newValue) {
      const updatedCustomers = customers.map(customer =>
        customer.id === rowData.id
          ? { ...customer, [field]: newValue }
          : customer
      )
      setCustomers(updatedCustomers)
      localStorage.setItem("customers", JSON.stringify(updatedCustomers))
    }
  }
  // useEffect(() => {

  //   setCustomers(sampleData)
  // }, [])
  // const header = renderHeader();
  const [visible, setVisible] = useState(false) // State to control the visibility of the modal
  const [inputValue, setInputValue] = useState("") // State to hold the input value
  const showDialog = () => {
    setSuccessAlert(true) // Show the modal
  }
  const hideDialog = () => {
    setVisible(false) // Hide the modal
  }
  const [successAlert, setSuccessAlert] = useState(false)
  const [addedit, setaddedit] = useState(false)
  const [date, setDate] = useState(null)
  const [date1, setDate1] = useState(null)
  const [date2, setDate2] = useState(null)
  const [date3, setDate3] = useState(null)
  const [date4, setDate4] = useState(null)
  const [date5, setDate5] = useState(null)
  const [date6, setDate6] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    Designation: "",
    status: "",
    employeeType: "",
    source: "",
    relocation: "",
    availabilityDate: null,
    referredBy: "",
    categories: "",
    groups: "",
    address: "",
    workPhone: "",
    mobilePhone: "",
    projectDescription: "",
  })
  const countries = [
    { name: "Australia", code: "AU" },
    { name: "Brazil", code: "BR" },
    { name: "China", code: "CN" },
    { name: "Egypt", code: "EG" },
    { name: "France", code: "FR" },
    { name: "Germany", code: "DE" },
    { name: "India", code: "IN" },
    { name: "Japan", code: "JP" },
    { name: "Spain", code: "ES" },
    { name: "United States", code: "US" },
  ]
  const [selectedCities, setSelectedCities] = useState(null)
  const cities = [
    { name: "New York", code: "NY" },
    { name: "Rome", code: "RM" },
    { name: "London", code: "LDN" },
    { name: "Istanbul", code: "IST" },
    { name: "Paris", code: "PRS" },
  ]
  const handleReset = () => {
    setFormData({
      firstName: "",
      lastName: "",
      company: "",
      email: "",
      Designation: "",
      status: "",
      employeeType: "",
      source: "",
      relocation: "",
      availabilityDate: null,
      referredBy: "",
      categories: "",
      groups: "",
      address: "",
      workPhone: "",
      mobilePhone: "",
      projectDescription: "",
    })
    setSelectedCountry(null)
    setSelectedCities(null)
  }

  // view page starts

  // Define the downloadResume function
  const downloadResume = () => {
    const doc = new jsPDF()

    // Get the Resume content
    const resumeContent = document.getElementById("resume-content")

    // Use the `html` method of jsPDF to capture the content and render it into the PDF
    doc.html(resumeContent, {
      callback: function (doc) {
        doc.save("Resume.pdf") // Save the generated PDF
      },
      margin: [10, 10, 10, 10], // Margin for the PDF
      x: 10, // X position for the start of the content
      y: 10, // Y position for the start of the content
      autoPaging: true, // Allow content to automatically flow to the next page if needed
      width: 180, // Set the content width
    })
  }

  // Project start




  const [worktypeFilters, setWorktypeFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    worktype_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    module: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    summary: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_manager: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });



  // Initialize worktype data state - will be populated from API
  const [worktypeData, setWorktypeData] = useState([]);
  const [isLoadingProjects, setIsLoadingProjects] = useState(false);

  // Project end


  // View worktype start

  const CompanyProjects = [

    {
      task_code: "Task-103",
      task_type: "Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Nitin Sharma",
      module_name: "Project Dashboard",
      task_name: "Create Gantt Chart View",
      task_description: "Add a Gantt chart to visualize project timelines.",
      created_by: "Rajashree Banerjee",
      assigned_by: "Nitin Sharma",
      assigned_to: "Lavankumar",
      watchers: "Rajashree Banerjee, Nitin Sharma",
      start_date: "06-05-2025",
      work_hours: 14,
      end_date: "09-05-2025",
      actual_end_date: "07-05-2025",
      task_status: "In Progress",
      priority: "High",
      approval_status: "Pending",
    },
    {
      task_code: "STask-103.1",
      task_type: "Sub Task",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Arun Pillai",
      module_name: "Notification Center",
      task_name: "Add SMS Alert Integration",
      task_description: "Integrate Twilio API to send SMS alerts to users.",
      created_by: "Pooja Srinivasan",
      assigned_by: "Arun Pillai",
      assigned_to: "Lavankumar",
      watchers: "Pooja Srinivasan",
      start_date: "04-05-2025",
      work_hours: 7,
      end_date: "05-05-2025",
      actual_end_date: "05-05-2025",
      task_status: "In Review",
      priority: "Medium",
      approval_status: "Approved",
    },
    {
      task_code: "Bug-103.1",
      task_type: "Bug",
      project_name: "AI Generator (Proj-101)",
      project_manager: "Devansh Goyal",
      module_name: "File Management",
      task_name: "Optimize File Uploads",
      task_description: "Improve file upload speed and add progress indicator.",
      created_by: "Sneha Rathi",
      assigned_by: "Devansh Goyal",
      assigned_to: "Lavankumar",
      watchers: "Sneha Rathi, Devansh Goyal",
      start_date: "03-05-2025",
      work_hours: 6,
      end_date: "04-05-2025",
      actual_end_date: "04-05-2025",
      task_status: "Completed",
      priority: "Low",
      approval_status: "Approved",
    },
  ]

  // Initialize with empty array - will be populated from API
  const [companyProjects, setCompanyProjects] = useState([])
  const [selectedCompanyProjects, setSelectedCompanyProjects] = useState([])

  const [companyProjectFilters, setCompanyProjectFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    project_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    summary: { value: null, matchMode: FilterMatchMode.CONTAINS },
    project_manager: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    delivery_manager: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    team_size: { value: null, matchMode: FilterMatchMode.EQUALS },
    start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
  })



  // View worktype end



  // view form activities starts

  const [activitiesFilters, setActivitiesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const activities = [];

  const [selectedActivities, setSelectedActivities] = useState([])

  // view form activities ends

  // view form history starts

  const [historyFilters, setHistoryFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const history = [];



  const [selectedHistory, setSelectedHistory] = useState([])

  // view form history ends

  // view form pipeline starts

  const [receivedEmployeeFilters, setReceivedEmployeeFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    designation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    candidate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  // const receivedEmployee = [
  //   {
  //     status: "Open",
  //     jobid: "Job-101",
  //     designation: "Web Developer",
  //     candidate: "LavanKumar Kalvala",
  //     contact: "Mahesh Kumar Bhoga",
  //     company: "Varun Digital Media",
  //     date_time: "26-02-2025 10:00 AM",
  //     user_id: "Harish",
  //   },
  //   // {
  //   //   status: "In Progress",
  //   //   jobid: "DEV002",
  //   //   designation: "Backend Developer",
  //   //   candidate: "Jane Smith",
  //   //   contact: "jane.smith@example.com",
  //   //   company: "Innovate Ltd.",
  //   //   date_time: "2024-12-15 02:30 PM",
  //   //   user_id: "54321",
  //   // },
  //   // {
  //   //   status: "Closed",
  //   //   jobid: "ANA001",
  //   //   designation: "Data Analyst",
  //   //   candidate: "Bob Brown",
  //   //   contact: "bob.brown@example.com",
  //   //   company: "Analytics Inc.",
  //   //   date_time: "2025-02-01 09:00 AM",
  //   //   user_id: "67890",
  //   // },
  //   // {
  //   //   status: "Closed",
  //   //   jobid: "ENG001",
  //   //   designation: "Mechanical Engineer",
  //   //   candidate: "Alice Carter",
  //   //   contact: "alice.carter@example.com",
  //   //   company: "Engineered Solutions",
  //   //   date_time: "2025-02-05 03:00 PM",
  //   //   user_id: "11223",
  //   // },
  //   // {
  //   //   status: "Closed",
  //   //   jobid: "HRM001",
  //   //   designation: "HR Manager",
  //   //   candidate: "Daniel Smith",
  //   //   contact: "daniel.smith@example.com",
  //   //   company: "PeopleFirst HR",
  //   //   date_time: "2025-01-25 11:30 AM",
  //   //   user_id: "33445",
  //   // },
  //   // {
  //   //   status: "Closed",
  //   //   jobid: "DEV001",
  //   //   designation: "Full Stack Developer",
  //   //   candidate: "Sophia Taylor",
  //   //   contact: "sophia.taylor@example.com",
  //   //   company: "Code Creators",
  //   //   date_time: "2025-01-15 02:15 PM",
  //   //   user_id: "55667",
  //   // },
  //   // {
  //   //   status: "Closed",
  //   //   jobid: "PM001",
  //   //   designation: "Project Manager",
  //   //   candidate: "James Wilson",
  //   //   contact: "james.wilson@example.com",
  //   //   company: "AgilePro Management",
  //   //   date_time: "2025-01-30 04:45 PM",
  //   //   user_id: "77889",
  //   // },
  // ]

  const [selectedReceivedEmployee, setSelectedReceivedEmployee] = useState([])

  // potential


























  // view form notes starts
  const [isEditorVisible, setEditorVisible] = useState(false) // Manage editor visibility
  const [editorContent, setEditorContent] = useState("") // Manage editor content
  const [editIndex, setEditIndex] = useState(null)
  const [editingNoteId, setEditingNoteId] = useState(null) // Track the ID of note being edited
  const [candidateNotes, setCandidateNotes] = useState([]) // Store notes in an array
  const [isLoadingNotes, setIsLoadingNotes] = useState(false) // Loading state for notes
  const [isSavingNote, setIsSavingNote] = useState(false) // Loading state for saving notes

  // Load notes for the current employee
  const loadEmployeeNotes = async (employeeId) => {
    if (!employeeId) return;

    try {
      setIsLoadingNotes(true);
      const response = await getEntityNotes('employees', employeeId);

      let notesData = [];
      if (response && Array.isArray(response)) {
        notesData = response;
      } else if (response && response.data && Array.isArray(response.data)) {
        notesData = response.data;
      } else if (response && response.results && Array.isArray(response.results)) {
        notesData = response.results;
      }

      // Transform the notes data to match expected format
      const transformedNotes = notesData.map(note => ({
        id: note.id,
        content: note.content || note.note || note.description || '',
        timestamp: note.created_at ? `Created on: ${new Date(note.created_at).toLocaleString()}` : 'Unknown Date',
        candidateName: `Note: ${fullName || 'Employee'}`,
        updated_at: note.updated_at,
        created_by: note.created_by || 'System'
      }));

      setCandidateNotes(transformedNotes);
      console.log('Loaded employee notes:', transformedNotes);
    } catch (error) {
      console.error('Failed to load employee notes:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load notes'
      });
    } finally {
      setIsLoadingNotes(false);
    }
  };

  const handleAddNotes = () => {
    if (!currentEmployeeId) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select an employee first'
      });
      return;
    }
    setEditorVisible(true) // Show the editor
    setEditorContent("") // Clear any previous content
    setEditIndex(null) // Reset editIndex when adding a new note
    setEditingNoteId(null) // Reset editing note ID
  }

  const handleSaveNotes = async () => {
    if (!editorContent.trim()) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter some content for the note'
      });
      return;
    }

    if (!currentEmployeeId) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'No employee selected'
      });
      return;
    }

    try {
      setIsSavingNote(true);

      const noteData = {
        content: editorContent.trim(),
        note_type: 'general', // You can make this dynamic based on requirements
      };

      if (editingNoteId !== null) {
        // Update existing note
        const response = await updateEntityNote('employees', currentEmployeeId, editingNoteId, noteData);

        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Note updated successfully'
        });
      } else {
        // Create new note
        const response = await createEntityNote('employees', currentEmployeeId, noteData);

        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Note created successfully'
        });
      }

      // Reload notes to get updated data
      await loadEmployeeNotes(currentEmployeeId);

      // Reset form
      setEditorContent("");
      setEditorVisible(false);
      setEditIndex(null);
      setEditingNoteId(null);

    } catch (error) {
      console.error('Failed to save note:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to save note'
      });
    } finally {
      setIsSavingNote(false);
    }
  }

  const handleCancelNotes = () => {
    setEditorContent("") // Clear editor content
    setEditorVisible(false) // Hide editor
    setEditIndex(null) // Reset editIndex on cancel
    setEditingNoteId(null) // Reset editing note ID
  }

  const handleEditNote = (index) => {
    const note = candidateNotes[index];
    if (!note) return;

    setEditorVisible(true)
    setEditorContent(note.content) // Load the note content into the editor
    setEditIndex(index) // Set editIndex to edit the current note
    setEditingNoteId(note.id) // Set the note ID for API update
  }

  const handleDeleteNote = async (index) => {
    const note = candidateNotes[index];
    if (!note || !note.id) return;

    if (!confirm('Are you sure you want to delete this note?')) {
      return;
    }

    try {
      await deleteEntityNote('employees', currentEmployeeId, note.id);

      // Remove note from local state
      const updatedNotes = candidateNotes.filter((_, i) => i !== index);
      setCandidateNotes(updatedNotes);

      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Note deleted successfully'
      });
    } catch (error) {
      console.error('Failed to delete note:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to delete note'
      });
    }
  }

  // Cleanup function when sidebar is closed
  const handleCloseSidebar = () => {
    setVisibleViewRight(false);
    // Clear notes-related state
    setCurrentEmployeeId(null);
    setSelectedCustomers([]);
    setCandidateNotes([]);
    setEditorVisible(false);
    setEditorContent("");
    setEditIndex(null);
    setEditingNoteId(null);
  };

  // view form notes ends

  // view page ends

  const [showesitSelecticon, setshowesitSelecticon] = useState(false)
  const [showesitSelect, setshowesitSelect] = useState(true)
  const [showIconsSelect, setShowIconsSelect] = useState(false)

  // sms

  const [selectedActSms, setSelectedActSms] = useState(null)

  const actSmsOptions = [
    {
      name: "Selected",
      code: "SMS-SE",
      icon: "pi pi-check",
    },
    {
      name: "Searched",
      code: "SMS-SR",
      icon: "pi pi-search",
    },
    {
      name: "All",
      code: "SMS-AL",
      icon: "pi pi-list",
    },
  ]

  const [selectedSchedule, setSelectedSchedule] = useState(null)

  const actScheduleOptions = [
    {
      name: "Interview",
      code: "SCH-IN",
      icon: "pi pi-user",
      action: () => SetInterviewpop(true),
    },
    {
      name: "Call",
      code: "SCH-CA",
      icon: "pi pi-phone",
      action: () => SetInterviewpopCall(true),
    },
    {
      name: "Meeting",
      code: "SCH-ME",
      icon: "pi pi-calendar",
      action: () => SetInterviewpopMeeting(true),
    },
    {
      name: "Task",
      code: "SCH-TA",
      icon: "pi pi-check-square",
      action: () => SetInterviewpopTask(true),
    },
    {
      name: "Event",
      code: "SCH-EV",
      icon: "pi pi-bell",
      action: () => SetInterviewpopEvent(true),
    },
    {
      name: "Other",
      code: "SCH-OT",
      icon: "pi pi-ellipsis-h",
      action: () => SetInterviewpopOther(true),
    },
  ]

  const handleScheduleChange = e => {
    setSelectedSchedule(e.value)

    // Trigger the action if defined for the selected option
    if (e.value && e.value.action) {
      e.value.action() // Execute the custom action
    }
  }

  // clear search starts

  const handleClearSearchCandidates = () => {
    setFilters({
      Firstname: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Lastname: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Designation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      MobilePhone: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Yearsofexperience: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      City: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      AvailabilityDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Relocation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Categories: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Groups: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      ResumeAttachment: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      PrimarySkills: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      CreatedBy: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      EditDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      CreateDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    })

  }

  // clear search ends

  // short form strats
  const [skillsOptions, setSkillsOptions] = useState([
    { value: "java", label: "Java" },
    { value: "react", label: "React" },
    { value: "nodejs", label: "Node.js" },
    // Add more skill options as needed
  ])

  const [selectedPrimarySkills, setSelectedPrimarySkills] = useState([])
  // Handle Primary Skills Selection
  const handlePrimarySkillsChange = selectedOptions => {
    setSelectedPrimarySkills(
      selectedOptions ? selectedOptions.map(option => option.value) : []
    )
  }

  const [selectedCompany, setSelectedCompany] = useState(null)
  const CompanyOptions = [
    { name: "Pranathi Software Services", code: "Pranathi" },
    { name: "Varun Digital Media", code: "Varun" },
    { name: "Vitel Global Communications", code: "Vitel" },
    { name: "SPG America", code: "SPG" },

  ]

  // short form ends

  const [categories] = useState([])

  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)

  //groups

  const [groups] = useState([])

  const [selectedGroupKey, setSelectedGroupKey] = useState(null)

  // Export start

  const [importCsvIcons, setImportCsvIcons] = useState(false)

  const exportCSVBtn = selectionOnly => {
    dt.current.exportCSV({ selectionOnly })
  }

  const exportPdfBtn = () => {
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("landscape")

        // Ensure columns and data are properly mapped
        const exportColumns = columns?.map(col => col.header) || []
        const exportData = customers.map(
          row => columns?.map(col => row[col.field] ?? "-") || []
        )

        // Debugging - Check if data is being prepared correctly
        console.log("Export Columns:", exportColumns)
        console.log("Export Data:", exportData)

        if (exportColumns.length === 0 || exportData.length === 0) {
          alert("No data available for export.")
          return
        }

        doc.autoTable({
          head: [exportColumns],
          body: exportData,
          startY: 20,
          styles: { fontSize: 8, cellPadding: 2 },
          theme: "grid",
          margin: { top: 10, left: 5, right: 5 },
          columnStyles: { 0: { cellWidth: 30 } },
        })

        doc.save("customers_data.pdf")
      })
    })
  }

  const exportExcelBtn = () => {
    import("xlsx").then(xlsx => {
      const exportData = customers.map(row =>
        columns?.reduce((acc, col) => {
          acc[col.header] = row[col.field] ?? "-" // Map field values with column headers
          return acc
        }, {})
      )

      const worksheet = xlsx.utils.json_to_sheet(exportData)
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] }
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      saveAsExcelFile(excelBuffer, "customers_data")
    })
  }

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then(module => {
      if (module && module.default) {
        const EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        const EXCEL_EXTENSION = ".xlsx"
        const data = new Blob([buffer], { type: EXCEL_TYPE })

        module.default.saveAs(
          data,
          `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
        )
      }
    })
  }

  const columns = [
    { field: "id", header: "ID" },
    { field: "Firstname", header: "First Name" },
    { field: "Lastname", header: "Last Name" },
    { field: "Designation ", header: "Job Title" },
    { field: "Email", header: "Email" },
    { field: "MobilePhone", header: "Mobile Phone" },
    { field: "Company", header: "Company" },
    { field: "Yearsofexperience", header: "Years of Experience" },
    { field: "City", header: "City" },
    { field: "Status", header: "Status" },
    { field: "Relocation", header: "Relocation" },
    { field: "Categories", header: "Categories" },
    { field: "Groups", header: "Groups" },
    { field: "PrimarySkills", header: "Primary Skills" },
    { field: "CreateDate", header: "Create Date" },
    { field: "EditDate", header: "Edit Date" },
    { field: "CreatedBy", header: "Created By" },
  ]

  const headerBtn = (
    <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
      <Button
        className="csvbtn p-button"
        icon="pi pi-file"
        rounded
        onClick={() => exportCSVBtn(false)}
        data-pr-tooltip="CSV"
        tooltip="Export to CSV"
      />
      <Button
        className="xlsbtn p-button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        onClick={exportExcelBtn}
        data-pr-tooltip="XLS"
        tooltip="Export to Excel"
      />
      <Button
        className="pdfbtn p-button me-2"
        icon="pi pi-file-pdf"
        severity="warning"
        rounded
        onClick={exportPdfBtn}
        disabled={customers.length === 0}
        data-pr-tooltip="PDF"
        tooltip="Export to Pdf"
      />
    </div>
  )

  // Export end

  // interview popup starts
  const [interviewpop, SetInterviewpop] = useState(false)
  const [interviewpopCall, SetInterviewpopCall] = useState(false)
  const [interviewpopMeeting, SetInterviewpopMeeting] = useState(false)
  const [interviewpopTask, SetInterviewpopTask] = useState(false)
  const [interviewpopEvent, SetInterviewpopEvent] = useState(false)
  const [interviewpopOther, SetInterviewpopOther] = useState(false)

  const [intertype, setintertype] = useState("Interview")
  const [intertype1, setintertype1] = useState("Task")
  const [intertype2, setintertype2] = useState("Meeting")
  const [intertype3, setintertype3] = useState("Call")
  const [intertype4, setintertype4] = useState("Event")
  const [intertype5, setintertype5] = useState("Other")

  const [subtype, setSubtype] = useState(null)
  const [subtypeget, setsubtypeget] = useState(null)
  const [startdate, setStartdate] = useState(null)
  const [starttime, setStarttime] = useState(null)
  const [endtime, setendtime] = useState(null)
  const [enddate, setenddate] = useState(null)
  const [popTextares, setPopTextares] = useState("")
  const [priority, setPriority] = useState(null)
  const [prioritycontact, setprioritycontact] = useState(null)
  const [condidatevalu, setcondidatevalu] = useState([])

  const typeInterview = [
    { name: "Screening Interviews", value: "SI" },
    { name: "One-on-One Interviews", value: "OOI" },
    { name: "Technical Interviews", value: "TI" },
    { name: "Final Round Interviews ", value: "FRI" },
    { name: "Video/Virtual Interviews", value: "VVI" },
  ]

  const typeCall = [
    { name: "Initial Screening Calls", value: "ISC" },
    { name: "Technical Assessment Calls", value: "TAC" },
    { name: "Behavioral Interview Calls ", value: "BIC" },
    { name: "Hiring Manager Calls", value: "HMC" },
    { name: "HR/Benefits Discussion Calls", value: "HRBDC" },
    { name: "Reference Check Calls", value: "RCC" },
    { name: "Panel Interview Calls", value: "PIC" },
    { name: "Follow-up Calls ", value: "FC" },
    { name: "Offer Discussion Calls ", value: "ODC" },
    { name: "Onboarding Coordination Calls", value: "OCC" },
    { name: "Status Update Calls", value: "SUC" },
    { name: "Candidate Feedback Calls", value: "CFC" },
  ]

  const typeMeeting = [
    { name: "Planning Meetings", value: "PM" },
    { name: "Job Requirements Meetings", value: "JRM" },
    { name: "Recruitment Team Sync-ups", value: "RTS" },
    { name: "Hiring Committee Meetings", value: "HCM" },
    { name: "Interview Panel Briefings", value: "IPB" },
    { name: "Candidate Feedback Meetings", value: "CFM" },
    { name: "Selection Meetings", value: "SM" },
    { name: "Budget Meetings", value: "BM" },
    { name: "Stakeholder Updates", value: "SU" },
    { name: "Recruitment Vendor Meetings", value: "RVM" },
    { name: "Onboarding Planning Meetings", value: "OPM" },
    { name: "Process Improvement Meetings", value: "PIM" },
    { name: "Training Meetings", value: "TM" },
    { name: "Compliance Meetings", value: "CM" },
  ]

  const ProjectStatusDrop = [
    { name: "Open", value: "Open" },
    { name: "Closed", value: "Closed" },
    { name: "On Hold", value: "On Hold" },
  ]

  const priorityValue = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const [reminder, setReminder] = useState(null)
  const reminderOptions = [
    { name: "0 mins", value: "0 mins" },
    { name: "5 mins", value: "5 mins" },
    { name: "10 mins", value: "10 mins" },
    { name: "15 mins", value: "15 mins" },
    { name: "30 mins", value: "30 mins" },
  ]
  const [repeat, setRepeat] = useState(null)
  const repeatOptions = [
    { name: "Do not repeat", value: "none" },
    { name: "Daily", value: "daily" },
    { name: "Weekly", value: "weekly" },
    { name: "Mon-Fri", value: "mon-fri" },
  ]

  const [followup, setFollowup] = useState(null)

  // Dropdown options
  const followupOptions = [
    { name: "None", value: "none" },
    { name: "1 Day", value: "1 Day" },
    { name: "2 Days", value: "2 Day" },
    { name: "3 Days", value: "3 Day" },
  ]

  // const [typeInterviewval, settypeInterviewval] = useState([])
  // const [typeInterviewcontact, settypeInterviewcontact] = useState([])
  const [typeInterviewcondi, settypeInterviewcondi] = useState([])
  const [subjectval, setsubjectval] = useState(null)
  const [popchecked2, setPopchecked2] = useState(false)
  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.checked)
  }

  const typeInterviewcontact = [
    { name: "Harish", value: "Harish" },
    { name: "Giri", value: "Giri" },
    { name: "Pavan", value: "Pavan" },
  ]

  const typeInterviewval = [
    { name: "Open", value: "Open" },
    { name: "Closed", value: "1 Day" },
    { name: "On Hold", value: "2 Day" },
    // { name: '3 Days', value: '3 Day' },
  ]

  const [userid, setUserid] = useState(["Harish"])
  const customChip = item => {
    return (
      <div>
        <span>{item}</span>
        {/* <i className="pi pi-user-plus"></i> */}
      </div>
    )
  }
  const [popchecked, setPopchecked] = useState(false)
  const handlePopupCheckbox = e => {
    setPopchecked(e.checked)
  }
  // interview popup ends

  // Create a Candidate start

  const navigate = useNavigate()
  const [createFirst, setCreateFirst] = useState("Lavankumar")
  const [createLast, setCreateLast] = useState("Kalvala")
  const [createEmail, setCreateEmail] = useState("lava9@infosys.com")
  const [createPhone, setCreatePhone] = useState("9876543211")
  const [createOfficePhone, setCreateOfficePhone] = useState("")
  const [createDesignation, setCreateDesignation] = useState("Web Developer")
  const [createCompany, setCreateCompany] = useState("Varun Digital Media")
  const [createDate, setCreateDate] = useState("28-02-2025")
  const [notes1, setNotes1] = useState("Lavankumar Kalvala is a Frontend Developer at Varun Digital Media, skilled in JavaScript and React. He is currently active and available for work from 20-02-2025. With 2 years of experience, he is open to relocation and belongs to the Frontend category (React group).")

  // Function to reset form fields
  const resetCreateForm = () => {
    setCreateFirst("")
    setCreateLast("")
    setCreateEmail("")
    setCreatePhone("")
    setCreateOfficePhone("")
    setCreateDesignation("")
    setCreateCompany("")
    setCreateDate("")
    setNotes1("")
    setSelectedModule(null)
    setSelectedDesignation(null)
    setSelectedEmployeeType(null)
    setSelectedDepartment(null)
    setSelectedWorkLocation(null)
    setSelectedShiftTiming(null)
    setSelectedEmployeeStatus(null)
    setSelectedCategoryKey(null)
    setSelectedNodeKey(null)
    setSelectedGroupKey(null)
    setselectedgroupKey(null)
    setSelectedPrimarySkills([])
  };

  // Handler to create employee via API
  const createEmployeeHandler = async () => {
    // Extract company ID from selected company - try multiple paths
    let companyId = null;

    if (selectedModule) {
      // Try to get the original numeric ID from the database
      companyId = selectedModule.__original?.id || selectedModule.id;

      // Convert to number if it's a stringified number
      if (typeof companyId === 'string' && !isNaN(companyId) && !companyId.startsWith('custom-')) {
        companyId = parseInt(companyId, 10);
      }
    }

    // Validate company selection
    if (!companyId || companyId === 'divider' || String(companyId).startsWith('create-new-') || String(companyId).startsWith('edit-selected-') || String(companyId).startsWith('custom-')) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a valid company'
      })
      return;
    }

    // Extract designation ID from selected designation
    let designationId = null;
    if (selectedDesignation) {
      designationId = selectedDesignation.__original?.id || selectedDesignation.id;
      // Convert to number if it's a stringified number
      if (typeof designationId === 'string' && !isNaN(designationId)) {
        designationId = parseInt(designationId, 10);
      }
    }

    // Validate designation selection
    if (!selectedDesignation) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a valid designation'
      })
      return;
    }

    // Validate categories selection
    const categoryId = extractCategoryId(selectedCategoryKey, categoriesitem);
    if (!categoryId) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a category'
      })
      return;
    }

    // Validate groups selection  
    const groupId = extractGroupId(selectedGroupKey, groupitem);
    if (!groupId) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a group'
      })
      return;
    }

    // Validate required fields
    if (!createFirst?.trim()) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'First name is required'
      })
      return;
    }

    if (!createLast?.trim()) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Last name is required'
      })
      return;
    }

    if (!createEmail?.trim()) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Email is required'
      })
      return;
    }

    if (!createPhone?.trim()) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Phone number is required'
      })
      return;
    }

    // Format date to YYYY-MM-DD format
    const formatDateToAPI = (dateStr) => {
      if (!dateStr) return null;

      // If already in YYYY-MM-DD format, return as is
      if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return dateStr;
      }

      // Handle DD-MM-YYYY format
      if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
        const [day, month, year] = dateStr.split('-');
        return `${year}-${month}-${day}`;
      }

      // Handle Date object
      if (dateStr instanceof Date) {
        return dateStr.toISOString().split('T')[0];
      }

      return dateStr;
    };

    const payload = {
      first_name: createFirst,
      last_name: createLast,
      primary_email: createEmail,
      personal_phone: createPhone,
      office_phone: createOfficePhone || createPhone, // Use office phone or fallback to personal phone
      designation: selectedDesignation, // Send designation ID instead of string
      company: companyId, // Send company ID instead of company_name
      date_of_joining: formatDateToAPI(createDate),
      description: notes1,
      categories: categoryId ? [categoryId] : [], // Wrap in array for many-to-many field
      groups: groupId ? [groupId] : [], // Wrap in array for many-to-many field
      primary_skills: Array.isArray(selectedPrimarySkills)
        ? selectedPrimarySkills.join(', ') // Convert array to comma-separated string
        : selectedPrimarySkills || "", 
        // Use string or empty string
        employee_type:selectedEmployeeType,
        department:selectedDepartment,
        work_location:selectedWorkLocation,
        shift_timings:selectedShiftTiming,
        city:selectedCity,
        is_private:privateDrop,
        private_users: PrivetDropdown.map(user => user.code)  ,
    }

    console.log("Employee payload:", payload); // Debug log
    console.log("Selected company:", selectedModule); // Debug log
    console.log("Selected designation:", selectedDesignation); // Debug log
    console.log("Category ID:", categoryId); // Debug log
    console.log("Group ID:", groupId); // Debug log

    try {
      await createEmployee(payload)
      toast.current.show({ severity: 'success', summary: 'Created', detail: 'Employee created successfully' })

      // Reset form fields after successful creation
      resetCreateForm();

      setVisibleRight(false)
      getAllActive(first, rows)
    } catch (error) {
      console.error('Create employee error:', error)
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create employee';
      toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage })
    }
  }

  // import resume
  const toast = useRef(null)


  const customBase64Uploader = async event => {
    try {
      // Access the uploaded file
      const file = event.files[0]
      console.log("File selected:", file)

      // Redirect the user immediately after file submission
      navigate("/employee-edit")

      // Optional: Process the file in the background
      const blob = await fetch(file.objectURL).then(r => r.blob())
      const reader = new FileReader()
      reader.readAsDataURL(blob)

      reader.onloadend = function () {
        const base64data = reader.result // Base64 encoded data
        console.log("Base64 Encoded Data:", base64data)
      }
    } catch (error) {
      console.error("Error during file upload:", error)
    }
  }

  const customBase64Uploader1 = async event => {
    try {
      // Access the uploaded file
      const file = event.files[0]
      console.log("File selected:", file)

      // Redirect the user immediately after file submission
      navigate("/uploadresumeform")

      // Optional: Process the file in the background
      const blob = await fetch(file.objectURL).then(r => r.blob())
      const reader = new FileReader()
      reader.readAsDataURL(blob)

      reader.onloadend = function () {
        const base64data = reader.result // Base64 encoded data
        console.log("Base64 Encoded Data:", base64data)
      }
    } catch (error) {
      console.error("Error during file upload:", error)
    }
  }

  // Company work type start


  const [selectedModule, setSelectedModule] = useState('')
  // Company work types - will be populated from database, these are fallback values
  const [moduleWorkTypes, setModuleWorkTypes] = useState([ ])

  const moduleDropdownWorkTypes = [
    ...moduleWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Company", id: "create-new-work-type" },
    { name: "Edit Company", id: "edit-selected-work-type" },
  ]

  const handleModuleWorkTypesChange = updatedWorkTypes => {
    setModuleWorkTypes(updatedWorkTypes)
  }

  const handleModuleSelectionChange = selectedWorkType => {
    setSelectedModule(selectedWorkType)
    console.log("Selected company:", selectedWorkType); // Debug log to see what's selected

    // Auto-populate office phone from selected company
    if (selectedWorkType && selectedWorkType.__original) {
      const companyData = selectedWorkType.__original;
      console.log("Company data:", companyData); // Debug log to see available fields

      // Try different possible field names for office phone in order of preference
      const officePhone = companyData.office_phone ||
        companyData.phone_number ||
        companyData.phone ||
        companyData.contact_phone ||
        companyData.company_phone ||
        companyData.business_phone ||
        companyData.main_phone ||
        "";

      if (officePhone && officePhone.trim()) {
        setCreateOfficePhone(officePhone.trim());
        console.log("Auto-populated office phone from company:", officePhone);
      } else {
        console.log("No office phone found in company data");
        // Clear office phone if no phone number found in company
        setCreateOfficePhone("");
      }
    } else {
      // Clear office phone if no company selected
      setCreateOfficePhone("");
    }
  }

  // Company work type end

  // Designation work type start
  const [selectedDesignation, setSelectedDesignation] = useState(null)
  const [designationWorkTypes, setDesignationWorkTypes] = useState([]);
  const designationDropdownWorkTypes = [
    ...designationWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Designation", id: "create-new-designation-type" },
    { name: "Edit Designation", id: "edit-selected-designation-type" },
  ]

  const handleDesignationWorkTypesChange = updatedWorkTypes => {
    setDesignationWorkTypes(updatedWorkTypes)
  }

  const handleDesignationSelectionChange = selectedWorkType => {
    setSelectedDesignation(selectedWorkType)
  }
  // Designation work type end

  // Employee Type work type start
  const [selectedEmployeeType, setSelectedEmployeeType] = useState(null)

  const [employeeTypeWorkTypes, setEmployeeTypeWorkTypes] = useState([]);

  const employeeTypeDropdownWorkTypes = [
    ...employeeTypeWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Employee Type", id: "create-new-emp-type" },
    { name: "Edit Employee Type", id: "edit-selected-emp-type" },
  ]

  const handleEmployeeTypeWorkTypesChange = updatedWorkTypes => {
    setEmployeeTypeWorkTypes(updatedWorkTypes)
  }

  const handleEmployeeTypeSelectionChange = selectedWorkType => {
    setSelectedEmployeeType(selectedWorkType)
  }
  // Employee Type work type end

  // Department work type start
  const [selectedDepartment, setSelectedDepartment] = useState(null)

  const [departmentWorkTypes, setDepartmentWorkTypes] = useState([]);

  const departmentDropdownWorkTypes = [
    ...departmentWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Department", id: "create-new-dept-type" },
    { name: "Edit Department", id: "edit-selected-dept-type" },
  ]

  const handleDepartmentWorkTypesChange = updatedWorkTypes => {
    setDepartmentWorkTypes(updatedWorkTypes)
  }

  const handleDepartmentSelectionChange = selectedWorkType => {
    setSelectedDepartment(selectedWorkType)
  }
  // Department work type end

  // Work Location work type start
  const [selectedWorkLocation, setSelectedWorkLocation] = useState(null)

  const [workLocationWorkTypes, setWorkLocationWorkTypes] = useState([]);

  const workLocationDropdownWorkTypes = [
    ...workLocationWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Work Location", id: "create-new-location-type" },
    { name: "Edit Work Location", id: "edit-selected-location-type" },
  ]

  const handleWorkLocationWorkTypesChange = updatedWorkTypes => {
    setWorkLocationWorkTypes(updatedWorkTypes)
  }

  const handleWorkLocationSelectionChange = selectedWorkType => {
    setSelectedWorkLocation(selectedWorkType)
  }
  // Work Location work type end

  // Shift Timings work type start
  const [selectedShiftTiming, setSelectedShiftTiming] = useState(null)

  const [shiftTimingWorkTypes, setShiftTimingWorkTypes] = useState([]);

  const shiftTimingDropdownWorkTypes = [
    ...shiftTimingWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Shift Timing", id: "create-new-shift-type" },
    { name: "Edit Shift Timing", id: "edit-selected-shift-type" },
  ]

  const handleShiftTimingWorkTypesChange = updatedWorkTypes => {
    setShiftTimingWorkTypes(updatedWorkTypes)
  }

  const handleShiftTimingSelectionChange = selectedWorkType => {
    setSelectedShiftTiming(selectedWorkType)
  }
  // Shift Timings work type end

  // Projects work type start
  const [selectedProject, setSelectedProject] = useState(null)
  const [projectWorkTypes, setProjectWorkTypes] = useState([]);

  const projectDropdownWorkTypes = [
    // Will be populated from API
  ];

  const handleProjectWorkTypesChange = updatedWorkTypes => {
    setProjectWorkTypes(updatedWorkTypes)
  }

  const handleProjectSelectionChange = selectedWorkType => {
    setSelectedProject(selectedWorkType)
  }
  // Projects work type end

  // WorkTypes work type start
  const [selectedWorkType, setSelectedWorkType] = useState(null)
  const [actualWorkTypes, setActualWorkTypes] = useState([]);
  console.log("Actual Work Types:", actualWorkTypes); // Debug log to verify state

  const workTypeDropdownWorkTypes = [
    // Will be populated from API
  ];

  const handleWorkTypeWorkTypesChange = updatedWorkTypes => {
    setActualWorkTypes(updatedWorkTypes)
  }

  const handleWorkTypeSelectionChange = selectedWorkType => {
    setSelectedWorkType(selectedWorkType)
  }
  // WorkTypes work type end

  // City work type start
  const [selectedCity, setSelectedCity] = useState('')

  const [cityWorkTypes, setCityWorkTypes] = useState([
    {
      name: "Hyderabad",
      color: "#000000",
      id: "city-1",
      statuses: ["Tech Hub", "IT Corridor", "HITEC City"],
    },
    {
      name: "Chennai",
      color: "#000000",
      id: "city-2",
      statuses: ["IT Hub", "OMR", "Sholinganallur"],
    },
    {
      name: "Mumbai",
      color: "#000000",
      id: "city-3",
      statuses: ["Financial Capital", "BKC", "Lower Parel"],
    },
    {
      name: "Bangalore",
      color: "#000000",
      id: "city-4",
      statuses: ["Silicon Valley", "Electronic City", "Whitefield"],
    },
    {
      name: "Delhi",
      color: "#000000",
      id: "city-5",
      statuses: ["NCR", "Gurgaon", "Noida"],
    },
  ])

  const cityDropdownWorkTypes = [
    ...cityWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add City", id: "create-new-city-type" },
    { name: "Edit City", id: "edit-selected-city-type" },
  ]

  const handleCityWorkTypesChange = updatedWorkTypes => {
    setCityWorkTypes(updatedWorkTypes)
  }

  const handleCitySelectionChange = selectedWorkType => {
    setSelectedCity(selectedWorkType)
  }
  // City work type end

  // Employee Status work type start
  const [selectedEmployeeStatus, setSelectedEmployeeStatus] = useState(null)

  const [employeeStatusWorkTypes, setEmployeeStatusWorkTypes] = useState([]);

  const employeeStatusDropdownWorkTypes = [
    ...employeeStatusWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Employee Status", id: "create-new-emp-status-type" },
    { name: "Edit Employee Status", id: "edit-selected-emp-status-type" },
  ]

  const handleEmployeeStatusWorkTypesChange = updatedWorkTypes => {
    setEmployeeStatusWorkTypes(updatedWorkTypes)
  }

  const handleEmployeeStatusSelectionChange = selectedWorkType => {
    setSelectedEmployeeStatus(selectedWorkType)
  }
  // Employee Status work type end
  const handlenotesAdd = async () => {
    const notesData = {
      "type": "Note",
      "content": notes,
      is_important: true,
      is_private: popchecked,
      private_users: privateDrop,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_Company_Contact}/company/employees/${selectedCustomers[0]?.id}/notes/`,
      notesData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 201) {
      setNotes("")
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Notes added successfully!' })
      setNotespopup(false)
      setSelectedCustomers([])
      setSelectedEmployee([])
    }
  }
  const [lastSelectedDesignationId, setLastSelectedDesignationId] = useState(null);
  const [lastSelectedDepartmentId, setLastSelectedDepartmentId] = useState(null);
  const [lastSelectedCategoryId, setLastSelectedCategoryId] = useState(null);
  const [lastSelectedGroupId, setLastSelectedGroupId] = useState(null);
  const [lastSelectedEmployeeTypeId, setLastSelectedEmployeeTypeId] = useState(null);
  const [lastSelectedWorkLocationId, setLastSelectedWorkLocationId] = useState(null);
  const [lastSelectedShiftTimingId, setLastSelectedShiftTimingId] = useState(null);
  const [lastSelectedWorkTypeId, setLastSelectedWorkTypeId] = useState(null);
  const [lastSelectedEmployeeStatusId, setLastSelectedEmployeeStatusId] = useState(null);

  useEffect(() => {
    // If a real designation id is chosen, store it
    if (selectedDesignation && selectedDesignation !== 'add' && selectedDesignation !== 'edit') {
      setLastSelectedDesignationId(selectedDesignation);
    }
    console.log("Selected designation changed:", selectedDesignation); // Debug log
    
    // Add flow: open blank modal
    if (selectedDesignation === 'add') {
      setLookupModalVisible(true);
      setLookupFormValue('');
      setLookupDescription('')
      setEditingLookup(false);
      setLookupModalContext('designation');
      setSelectedDesignation(null);
      return;
    }

    // Edit flow: prefill with last selected id
    if (selectedDesignation === 'edit') {
      if (lastSelectedDesignationId) {
        setEditingLookup(true);
        const current = designationWorkTypes?.find(opt => String(opt.id) === String(lastSelectedDesignationId));
        setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
        setLookupDescription((current && (current.description || current.desc)) || '')
        setLookupModalVisible(true);
        setLookupModalContext('designation');
        setLastSelectedLookupId(lastSelectedDesignationId);
        setSelectedDesignation(lastSelectedDesignationId);
        setSelectedEditdrop(lastSelectedDesignationId)
      } else {
        console.warn('No designation selected to edit!');
      }
    }
  }, [selectedDesignation, lastSelectedDesignationId, designationWorkTypes]);
  useEffect(() => {
    // If a real department id is chosen, store it
    if (selectedDepartment && selectedDepartment !== 'add' && selectedDepartment !== 'edit') {
      setLastSelectedDepartmentId(selectedDepartment);
    }

    // Add flow: open blank modal
    if (selectedDepartment === 'add') {
      setLookupModalVisible(true);
      setLookupFormValue('');
      setLookupDescription('')
      setEditingLookup(false);
      setLookupModalContext('department');
      setSelectedDepartment(null);
      return;
    }

    // Edit flow: prefill with last selected id
    if (selectedDepartment === 'edit') {
      if (lastSelectedDepartmentId) {
        setEditingLookup(true);
        const current = departmentWorkTypes?.find(opt => String(opt.id) === String(lastSelectedDepartmentId));
        setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
        setLookupDescription((current && (current.description || current.desc)) || '')
        setLookupModalVisible(true);
        setLookupModalContext('department');
        setLastSelectedLookupId(lastSelectedDepartmentId);
        setSelectedDepartment(lastSelectedDepartmentId);
        setSelectedEditdrop(lastSelectedDepartmentId);
      } else {
        console.warn('No department selected to edit!');
      }
    }
  }, [selectedDepartment, lastSelectedDepartmentId, departmentWorkTypes]);
  useEffect(() => {
    // If a real designation id is chosen, store it
    if (selectedEmployeeType && selectedEmployeeType !== 'add' && selectedEmployeeType !== 'edit') {
      setLastSelectedEmployeeTypeId(selectedEmployeeType);
    }

    // Add flow: open blank modal
    if (selectedEmployeeType === 'add') {
      setLookupModalVisible(true);
      setLookupFormValue('');
      setLookupDescription('')
      setEditingLookup(false);
      setLookupModalContext('employeeType');
      setSelectedEmployeeType(null);
      return;
    }

    // Edit flow: prefill with last selected id
    if (selectedEmployeeType === 'edit') {
      if (lastSelectedEmployeeTypeId) {
        setEditingLookup(true);
        const current = employeeTypeWorkTypes?.find(opt => String(opt.id) === String(lastSelectedEmployeeTypeId));
        setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
        setLookupDescription((current && (current.description || current.desc)) || '')
        setLookupModalVisible(true);
        setLookupModalContext('employeeType');
        setLastSelectedLookupId(lastSelectedEmployeeTypeId);
        setSelectedEmployeeType(lastSelectedEmployeeTypeId);
        setSelectedEditdrop(lastSelectedEmployeeTypeId);
      } else {
        console.warn('No employee type selected to edit!');
      }
    }
  }, [selectedEmployeeType, lastSelectedEmployeeTypeId, employeeTypeWorkTypes]);
  useEffect(() => {
    // If a real designation id is chosen, store it
    if (selectedWorkLocation && selectedWorkLocation !== 'add' && selectedWorkLocation !== 'edit') {
      setLastSelectedWorkLocationId(selectedWorkLocation);
    }

    // Add flow: open blank modal
    if (selectedWorkLocation === 'add') {
      setLookupModalVisible(true);
      setLookupFormValue('');
      setLookupDescription('')
      setEditingLookup(false);
      setLookupModalContext('workLocation');
      setSelectedWorkLocation(null);
      return;
    }

    // Edit flow: prefill with last selected id
    if (selectedWorkLocation === 'edit') {
      if (lastSelectedWorkLocationId) {
        setEditingLookup(true);
        const current = workLocationWorkTypes?.find(opt => String(opt.id) === String(lastSelectedWorkLocationId));
        setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
        setLookupDescription((current && (current.description || current.desc)) || '')
        setLookupModalVisible(true);
        setLookupModalContext('workLocation');
        setLastSelectedLookupId(lastSelectedWorkLocationId);
        setSelectedWorkLocation(lastSelectedWorkLocationId);
        setSelectedEditdrop(lastSelectedWorkLocationId);
      } else {
        console.warn('No work location selected to edit!');
      }
    }
  }, [selectedWorkLocation, lastSelectedWorkLocationId, workLocationWorkTypes]);
  useEffect(() => {
    // If a real designation id is chosen, store it
    if (selectedShiftTiming && selectedShiftTiming !== 'add' && selectedShiftTiming !== 'edit') {
      setLastSelectedShiftTimingId(selectedShiftTiming);
    }

    // Add flow: open blank modal
    if (selectedShiftTiming === 'add') {
      setLookupModalVisible(true);
      setLookupFormValue('');
      setLookupDescription('')
      setEditingLookup(false);
      setLookupModalContext('shiftTiming');
      setSelectedShiftTiming(null);
      return;
    }

    // Edit flow: prefill with last selected id
    if (selectedShiftTiming === 'edit') {
      if (lastSelectedShiftTimingId) {
        setEditingLookup(true);
        const current = shiftTimingWorkTypes?.find(opt => String(opt.id) === String(lastSelectedShiftTimingId));
        setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
        setLookupDescription((current && (current.description || current.desc)) || '')
        setLookupModalVisible(true);
        setLookupModalContext('shiftTiming');
        setLastSelectedLookupId(lastSelectedShiftTimingId);
        setSelectedShiftTiming(lastSelectedShiftTimingId);
        setSelectedEditdrop(lastSelectedShiftTimingId);
      } else {
        console.warn('No shift timing selected to edit!');
      }
    }
  }, [selectedShiftTiming, lastSelectedShiftTimingId, shiftTimingWorkTypes]);
  useEffect(() => {
    // If a real designation id is chosen, store it
    if (selectedEmployeeStatus && selectedEmployeeStatus !== 'add' && selectedEmployeeStatus !== 'edit') {
      setLastSelectedEmployeeStatusId(selectedEmployeeStatus);
    }

    // Add flow: open blank modal
    if (selectedEmployeeStatus === 'add') {
      setLookupModalVisible(true);
      setLookupFormValue('');
      setLookupDescription('')
      setEditingLookup(false);
      setLookupModalContext('status');
      setSelectedEmployeeStatus(null);
      return;
    }

    // Edit flow: prefill with last selected id
    if (selectedEmployeeStatus === 'edit') {
      if (lastSelectedEmployeeStatusId) {
        setEditingLookup(true);
        const current = employeeStatusWorkTypes?.find(opt => String(opt.id) === String(lastSelectedEmployeeStatusId));
        setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
        setLookupDescription((current && (current.description || current.desc)) || '')
        setLookupModalVisible(true);
        setLookupModalContext('status');
        setLastSelectedLookupId(lastSelectedEmployeeStatusId);
        setSelectedEmployeeStatus(lastSelectedEmployeeStatusId);
        setSelectedEditdrop(lastSelectedEmployeeStatusId);
      } else {
        console.warn('No employee status selected to edit!');
      }
    }
  }, [selectedEmployeeStatus, lastSelectedEmployeeStatusId, employeeStatusWorkTypes]);
  useEffect(() => {
    // If a real designation id is chosen, store it
    if (selectedWorkType && selectedWorkType !== 'add' && selectedWorkType !== 'edit') {
      setLastSelectedWorkTypeId(selectedWorkType);
    }

    // Add flow: open blank modal
    if (selectedWorkType === 'add') {
      setLookupModalVisible(true);
      setLookupFormValue('');
      setLookupDescription('')
      setEditingLookup(false);
      setLookupModalContext('workType');
      setSelectedWorkType(null);
      return;
    }

    // Edit flow: prefill with last selected id
    if (selectedWorkType === 'edit') {
      if (lastSelectedWorkTypeId) {
        setEditingLookup(true);
        const current = actualWorkTypes?.find(opt => String(opt.id) === String(lastSelectedWorkTypeId));
        setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
        setLookupDescription((current && (current.description || current.desc)) || '')
        setLookupModalVisible(true);
        setLookupModalContext('workType');
        setLastSelectedLookupId(lastSelectedWorkTypeId);
        setSelectedWorkType(lastSelectedWorkTypeId);
        setSelectedEditdrop(lastSelectedWorkTypeId);
      } else {
        console.warn('No employee status selected to edit!');
      }
    }
  }, [selectedWorkType, lastSelectedWorkTypeId, actualWorkTypes]);
  useEffect(() => {
    if (lookupModalContext === 'designation') {
      setselecteddropoptions((designationWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.value || d.name || d.label || String(d.id), code: d.code, raw: d })));
    }
    else if (lookupModalContext === 'employeeType') {
      setselecteddropoptions((employeeTypeWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.name || d.value || d.label || String(d.id), code: d.code, raw: d })));
    }
    else if (lookupModalContext === 'department') {
      setselecteddropoptions((departmentWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.name || d.value || d.label || String(d.id), code: d.code, raw: d })));
    }
    else if (lookupModalContext === 'workLocation') {
      setselecteddropoptions((workLocationWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.name || d.value || d.label || String(d.id), code: d.code, raw: d })));
    }
    else if (lookupModalContext === 'shiftTiming') {
      setselecteddropoptions((shiftTimingWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.name || d.value || d.label || String(d.id), code: d.code, raw: d })));
    } else if (lookupModalContext === 'status') {
      setselecteddropoptions((employeeStatusWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.name || d.value || d.label || String(d.id), code: d.code, raw: d })));
    }
    else if (lookupModalContext === 'workType') {
      setselecteddropoptions((actualWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.name || d.value || d.label || String(d.id), code: d.code, raw: d })));
    } else if (lookupModalContext === 'category') {
      setselecteddropoptions((categories || []).map(c => ({ id: c.id ?? c.code ?? c.value, name: c.label || c.value || c.name || String(c.id), code: c.code, raw: c })));
    } else if (lookupModalContext === 'group') {
      setselecteddropoptions((groups || []).map(g => ({ id: g.id ?? g.code ?? g.value, name: g.label || g.value || g.name || String(g.id), code: g.code, raw: g })));
    } else {
      setselecteddropoptions([])
    }
  }, [lookupModalContext, designationWorkTypes, workLocationWorkTypes, shiftTimingWorkTypes, categories, departmentWorkTypes, groups])
  const lookupContextToName = (context) => {
    switch (context) {
      case 'designation':
        return 'employee_designation';
      case 'employeeType':
        return 'employee_employeeType';
      case 'department':
        return 'employee_department';
      case 'category':
        return 'employee_categories';
      case 'group':
        return 'employee_group';
      case 'workLocation':
        return 'employee_workLocation';
      case 'shiftTiming':
        return 'employee_shiftTimings';
      case 'status':
        return 'employee_employeeStatus';
      case 'workType':
        return 'employee_workTypes';
      // Add more cases as needed
      default:
        return null;
    }
  }
  const handleLookupSave = async () => {
    const context = lookupModalContext;
    const name = lookupContextToName(context);
    if (!name) return;
    try {
      if (lookupFormValue.trim() === '') {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty' })
        return;
      }
      const token = getCookie('access_token');
      const payload = { value: lookupFormValue, name, description: lookupDescription || lookupFormValue };

      if (editingLookup && lastSelectedLookupId) {
        // PATCH
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedLookupId}/`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        // POST
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      // Refresh the relevant list
      if (context === 'designation') getDesignationData();
      if (context === 'employeeType') getEmployeeTypeData();
      if (context === 'department') getDepartmentData();
      if (context === 'workLocation') getWorkLocationData();
      if (context === 'shiftTiming') getShiftTimingData();
      if (context === 'status') getEmployeeStatusData();
      if (context === 'workType') getWorkTypesData();
      // if (context === 'group') getGroupData();

      setLookupModalVisible(false);
      setLookupFormValue('');
      setEditingLookup(false);
      setLastSelectedLookupId(null);
      setLookupDescription('')
    } catch (err) {
      console.error('Lookup save failed', err);
    }
  }
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [subject, setSubject] = useState('');
  const [displayDialog, setDisplayDialog] = useState(false);
  const [FileNames, setFileNames] = useState([]);
  const [documentTypes, setdocumentTypes] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedDocId, setSelectedDocId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
    const handleEdit = (doc) => {
      console.log('Editing document:', doc);
      setDisplayDialog(true);
      setSelectedDocId(doc.id);
      setIsEdit(true);
      setSubject(doc.description);
      setSelectedDocument(doc.type || null);
      const LastFiles = Array.isArray(doc.files)
        ? doc.files.map((fileItem, index) => ({
          id: `${doc.id}-${index}`,
          selectedId: fileItem.id,
          name: fileItem.original_filename,
          url: fileItem.file,
        }))
        : doc.files
          ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
          : [];
  
      setFileNames(LastFiles);
    };
     const getDoctType = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                if (response.status===200) {
                        const options = response.data.results.results.map((category) => ({
                name: category.value
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase()),
                code: category.id,
                }));
                setdocumentTypes(options);
                }
            } catch (err) {
                console.log(err);
    
            }
        }
        useEffect(() => {
            getDoctType();
        }, []);
  const handleDelete = async (rowKey) => {
      console.log('Deleting document with key:', rowKey);
  
      try {
        const id = selectedCustomers?.[0]?.id;
        const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/employees/${id}/documents/${rowKey}/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          getDocuments()
          toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
        }
      } catch (err) {
        console.log(err);
  
      }
    }
    const handleUpdateDocument = async () => {
      if (!selectedDocument || !subject) {
        alert('Please fill all the fields.');
        return;
      }
  
      try {
        const formData = new FormData();
  
        // Document type
        const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
        const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
        formData.append('type', selectedDocument);
        formData.append('description', subject);
  
        // Append newly uploaded files
        if (uploadedFiles && uploadedFiles.length > 0) {
          uploadedFiles.forEach((file) => {
            formData.append('uploaded_files', file);
          });
        }
        if (FileNames && FileNames.length > 0) {
          FileNames.forEach((file) => {
            formData.append('files_to_keep', file.selectedId);
          });
        }
        const id = selectedCustomers[0]?.id
        const response = await axios.patch(
          `${process.env.REACT_APP_Company_Contact}/company/employees/${id}/documents/${selectedDocId}/`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        if (response.status == 200 || response.status == 201) {
          getDocuments();
          setDisplayDialog(false);
          setSelectedDocument(null);
          setSubject('');
          setFileNames([]);
          setUploadedFiles([]);
          setIsEdit(false);
        }
  
        toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });
  
      } catch (err) {
        console.error('Failed to update document', err);
        alert('Failed to update document');
      }
    };
  const handleAddDocument = async () => {
    try {
      const formData = new FormData();
      formData.append('type', selectedDocument || '');
      formData.append('description', subject || '');
      if (uploadedFiles instanceof File) {
        formData.append('uploaded_files', uploadedFiles);
      }
      else if (Array.isArray(uploadedFiles)) {
        uploadedFiles.forEach((file, idx) => {
          formData.append('uploaded_files', file);
        });
      }
      const id = selectedCustomers[0]?.id
      const response = await axios.post(
        `${process.env.REACT_APP_Company_Contact}/company/contacts/${id}/documents/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
  
  
        if (response.status === 201) {
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'Document added successfully', life: 3000 });
          // setDocuments(prev => [...prev, response.data]);
          setDisplayDialog(false);
          setSelectedDocument(null);
          setSubject('');
          setUploadedFiles(null);
          getData();
          getDocuments();
          // setFile(null);
        }
      } catch (error) {
        console.error('Error adding document:', error);
      }
    };
  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <div className="page-title-box actjobbread">
            {/* Action items start */}
            <Row className="justify-content-between ac-items">
              <Col xxl={10} xl={12} lg={12} md={12} sm={12}>
                <span className="addcan-ac">
                  {selectedCustomers.length > 0 ? (
                    <span className="action-icons me-2">
                      <button
                        type="button"
                        className="btn btn-secondary import-res-btn me-1 md:w-8rem"
                      >
                        <i className="pi pi-user"></i>{" "}
                        {selectedCustomers.length} Selected
                      </button>

                      <span className="icons-ac">
                        <Tooltip
                          target=".view"
                          content="View"
                          position="bottom"
                          style={{ marginTop: "5px" }}
                        />

                        <button
                          type="button"
                          class="btn btn-secondary icons-btn ms-1 view"
                          onClick={() => {
                            if (selectedCustomers && selectedCustomers.length > 0) {
                              // view the first selected customer
                              handleViewSelected(selectedCustomers[0]);
                            } else {
                              toast.current.show({ severity: 'warn', summary: 'No Selection', detail: 'Select at least one employee to view' });
                            }
                          }}
                        >
                          <i className="pi pi-eye"></i>
                        </button>

                        <Tooltip
                          target=".edit"
                          content="Edit"
                          position="top"
                          style={{ marginBottom: "5px" }}
                        />

                        <button
                          type="button"
                          className="btn btn-secondary icons-btn ms-1 edit"
                          onClick={() => {
                            if (selectedCustomers && selectedCustomers.length > 0) {
                              // Edit the first selected employee
                              navigate(`/employee-edit?id=${selectedCustomers[0].id}`);
                            } else {
                              toast.current.show({ severity: 'warn', summary: 'No Selection', detail: 'Select at least one employee to edit' });
                            }
                          }}
                        >
                          <i className="pi pi-pencil"></i>
                        </button>

                        <Tooltip
                          target=".delete"
                          content="Delete"
                          position="bottom"
                          style={{ marginTop: "5px" }}
                        />
                        <button
                          type="button"
                          className="btn btn-secondary icons-btn ms-1 delete"
                          onClick={() => {
                            if (selectedCustomers && selectedCustomers.length > 0) {
                              handleBulkDelete();
                            } else {
                              toast.current.show({ severity: 'warn', summary: 'No Selection', detail: 'Select at least one employee to delete' });
                            }
                          }}
                        >
                          <i className="pi pi-trash"></i>
                        </button>

                        <Tooltip
                          target=".archived"
                          content="Archive"
                          position="top"
                          style={{ marginBottom: "5px" }}
                        />

                        <button
                          type="button"
                          className="btn btn-secondary icons-btn ms-1 archived"
                          onClick={() => handleArchived(selectedCustomers)}
                        >
                          <i className="pi pi-check-circle"></i>
                        </button>
                      </span>
                    </span>
                  ) : (
                    <div>
                            <h4 className="mb-0 bold-500">Employees</h4>
                        </div>
                    // <button
                    //   type="button"
                    //   className="btn btn-secondary import-res-btn md:w-10rem me-1"
                    //   onClick={() => {
                    //     resetCreateForm(); // Reset form fields
                    //     setVisibleRight(true)
                    //   }}
                    // >
                    //   <i className="pi pi-user me-1"></i> Add a Employee
                    // </button>
                  )}
                </span>


              </Col>

              <Col xxl={2} xl={12} lg={12} sm={12}>
                <div className="clr-icons">
                  <Dropdown
                    id="company"
                    value={selectedModule}
                    options={moduleWorkTypes}
                    onChange={e => { setSelectedModule(e.value);getAllActive(first, rows,e.value) }}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Company"
                    className="w-full bgclr"
                    style={{ marginRight: "5px", backgroundColor: "#fff" }} 
                  />
                  <Tooltip
                    target=".notes"
                    content="Notes"
                    position="top"
                    style={{ marginBottom: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 notes"
                    onClick={() => setNotespopup(true)}
                  >
                    <i className="pi pi-file"></i>
                  </button>

                  <Tooltip
                    target=".export"
                    content="Export"
                    position="top"
                    style={{ marginBottom: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 export"
                    onClick={() => setImportCsvIcons(!importCsvIcons)}
                    data-pr-tooltip="Export"
                    tooltip="Export"
                  >
                    <i className="pi pi-file-export"></i>
                  </button>

                  {importCsvIcons && <span>{headerBtn}</span>}

                  <Tooltip
                    target=".clear"
                    content="Clear Search"
                    position="bottom"
                    style={{ marginTop: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn clear"
                    onClick={handleClearSearchCandidates}
                    Tooltip="Clear Search"
                  >
                    <i className="pi pi-sync"></i>
                  </button>

                  <button
                    type="button"
                    className="mainbtn btn btn-secondary import-res-btn d-none"
                    tooltip="Merge"
                    tooltipOptions={{ position: "bottom" }}
                  >
                    <i className="pi pi-print"></i>
                  </button>
                </div>
              </Col>
            </Row>
            {/* Action items end */}

            {/* candidate table starts */}
            <Row>
              <Col sm={12}>
                <React.Fragment>
                  <section className="">
                    {/* Toast for notifications */}
                    <Toast ref={toast} />

                    {/* ContextMenu for right-click actions */}
                    <ContextMenu model={menuModel} ref={cm} onHide={() => setSelectedCandidate(null)} />

                    <div className="card1 mt-4 mb-4 actjobsumtable">
                      <DataTable
                        ref={dt}
                        value={candidateData}
                        rows={rows}
                        first={first}
                        // value={candidateData.slice(first, first + rows)}
                        // rows={rows}
                        // first={first}
                        rowsPerPageOptions={[5, 10, 25, 50]} // Rows per page options
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        onPage={onPage}
                        dataKey="id"
                        filters={filters}
                        filterDisplay="row"
                        loading={loading}
                        globalFilterFields={[
                          "id",
                          "Firstname",
                          "Lastname",
                          "MobilePhone",
                          "Designation  ",
                          "Email",
                          "Company",
                          "EditDate",
                          "Yearsofexperience",
                          "City",
                          "CreateDate",
                          "Status",
                          "Relocation",
                          "Categories",
                          "Groups",
                          "AvailabilityDate",
                          "PrimarySkills",
                          "CreatedBy",
                          "ResumeAttachment",
                        ]}
                        scrollable
                        emptyMessage="No customers found."
                        selection={selectedCustomers}
                        onSelectionChange={onSelectionChange}
                        selectionMode="multiple"
                        size={size}
                        reorderableRows
                        reorderableColumns
                        onRowReorder={onRowReorder}
                        // columnResizeMode = "expand"
                        rowGroupMode="rowspan"
                        rowClassName="row-bottom-color" // Apply custom row style
                        totalRecords={totalRecords} // Use backend-provided total
                        // scrollHeight="400px"
                        editMode="cell"
                        resizableColumns // Enable resizable columns
                        columnResizeMode="expand" // Choose between "fit" or "expand"
                        onContextMenu={(e) => {
                          cm.current.show(e.originalEvent); // Show the context menu
                          setSelectedCandidate(e.data); // Set the selected candidate
                        }}
                        contextMenuSelection={selectedCandidate}
                        onContextMenuSelectionChange={(e) => setSelectedCandidate(e.value)}
                      >
                        <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        />
                        <Column
                          field="first_name"
                          sortable
                          header="First Name"
                          frozen
                          filter
                          filterPlaceholder=""
                          filterMatchMode="startsWith"
                          editor={options => firstnameEditor(options)}
                          onCellEditComplete={onCellEditComplete}
                        />
                        <Column
                          field="last_name"
                          sortable
                          header="Last Name"
                          filter
                          filterPlaceholder=""
                          editor={options => firstnameEditor1(options)}
                          onCellEditComplete={onCellEditComplete}
                        />
                        <Column
                          field="designation"
                          sortable
                          header="Designation"
                          filter
                          filterPlaceholder=""
                          body={(rowData) => {
                            if (!rowData.designation) return '';
                            const designation = designationWorkTypes.find(d => d.id == rowData.designation);
                            return designation ? designation.name : rowData.designation;
                          }}
                        />
                        <Column
                          field="primary_email"
                          sortable
                          header="Email"
                          filter
                          filterPlaceholder=""
                          editor={options => firstnameEditor4(options)}
                          onCellEditComplete={onCellEditComplete}
                        />
                        <Column
                          field="office_phone"
                          sortable
                          header="Mobile Phone"
                          filter
                          filterPlaceholder=""
                        // editor={options => firstnameEditor2(options)}
                        // onCellEditComplete={onCellEditComplete}
                        />
                        <Column
                          field="company_name"
                          sortable
                          header="Company"
                          filter
                          filterPlaceholder=""
                        />
                        <Column
                          field="total_experience"
                          sortable
                          header="Yrs. of Exp."
                          filter
                          filterPlaceholder=""
                        />
                        {/* <Column
                          field="city"
                          header="City"
                          sortable
                          filter
                          filterPlaceholder=""
                        /> */}
                        <Column
                          field="is_archived"
                          header="Status"
                          sortable
                          filter
                          filterPlaceholder=""
                          filterElement={statusofdrop}
                          className="emp-status"
                          body={rowData => {
                            const isActive = !rowData.is_archived // Use is_archived field
                            const status = isActive ? "Active" : "Inactive"
                            let badgeClass = ""
                            // Define the badge style based on the status value
                            switch (status) {
                              case "Active":
                                badgeClass = "p-badge-success"
                                break
                              case "Inactive":
                                badgeClass = "p-badge-secondary"
                                break
                              case "Pending":
                                badgeClass = "p-badge-warning"
                                break
                              case "Completed":
                                badgeClass = "p-badge-info"
                                break
                              default:
                                badgeClass = "p-badge-outline"
                                break
                            }
                            return (
                              <span className={`p-badge ${badgeClass}`}>
                                {status}
                              </span>
                            )
                          }}
                        />
                        {/* <Column
                          field="Relocation"
                          sortable
                          header="Relocation"
                          filter
                          filterPlaceholder=""
                        /> */}
                        <Column
                          field="categories"
                          sortable
                          header="Categories"
                          filter
                          filterElement={representativeRowFilterTemplate}
                          className="emp-status"
                          body={(rowData) => {
                            if (Array.isArray(rowData.categories) && rowData.categories.length > 0) {
                              const categoryNames = rowData.categories.map(catId => {
                                const category = categoriesitem.find(c => c.category_id === catId || c.id === catId);
                                return category ? category.label : catId;
                              });
                              return categoryNames.join(', ');
                            }
                            return rowData.categories || '';
                          }}
                        />
                        <Column
                          field="groups"
                          header="Groups"
                          sortable
                          filter
                          filterElement={representativeRowFilterTemplate1}
                          className="emp-status"
                          body={(rowData) => {
                            if (Array.isArray(rowData.groups) && rowData.groups.length > 0) {
                              const groupNames = rowData.groups.map(groupId => {
                                const group = groupitem.find(g => g.group_id === groupId || g.id === groupId);
                                return group ? group.label : groupId;
                              });
                              return groupNames.join(', ');
                            }
                            return rowData.groups || '';
                          }}
                        />
                        <Column
                          field="primary_skills_list"
                          header="Primary Skills"
                          sortable
                          filter
                          filterPlaceholder=""
                          body={rowData => Array.isArray(rowData.primary_skills_list) ? rowData.primary_skills_list.join(', ') : ''}
                        />

                        <Column
                          field="created_at"
                          header="Create Date"
                          sortable
                          filter
                          filterPlaceholder=""
                          body={(rowData) => {
                            if (rowData.created_at) {
                              return new Date(rowData.created_at).toLocaleDateString();
                            }
                            return '';
                          }}
                        />
                        <Column
                          field="updated_at"
                          header="Edit Date"
                          sortable
                          filter
                          filterPlaceholder=""
                          body={(rowData) => {
                            if (rowData.updated_at) {
                              return new Date(rowData.updated_at).toLocaleDateString();
                            }
                            return '';
                          }}
                        />
                        <Column
                          field="created_by_name"
                          header="Created By"
                          sortable
                          filter
                          filterPlaceholder=""
                        />

                      </DataTable>
                    </div>
                  </section>
                </React.Fragment>
              </Col>
            </Row>
            {/* candidate table ends */}

            {/* Side bar start */}
            <Row>
              <Col lg={12}>
                <Sidebar
                  visible={visibleRight}
                  position="right"
                  onHide={() => setVisibleRight(false)}
                  className="sidebar"
                >
                  <div className="sidebar-header">
                    <h3>Create a Employee</h3>
                    <div className="d-flex align-items-center">
                      {/* <Link to="/employee-edit">
                        <p className="mb-0 text-white">
                          {" "}
                          <i className="fa-regular fa-pen-to-square me-3"></i>{" "}
                        </p>
                      </Link> */}
                      <Button
                        icon="pi pi-times"
                        className="p-button-text close-btn"
                        onClick={() => setVisibleRight(false)}
                      />
                    </div>
                  </div>
                  <div className="card sidebardetails">
                    <Row className="mb-3">
                      <Col lg={6}>
                        <label className="mb-0">First Name</label>
                        <InputText
                          placeholder="Enter first name"
                          value={createFirst}
                          onChange={e => setCreateFirst(e.target.value)}
                        />
                      </Col>
                      <Col lg={6}>
                        <label htmlFor="lastName" className="mb-0">
                          Last Name
                        </label>
                        <InputText
                          id="lastName"
                          name="lastName"
                          placeholder="Enter last name"
                          value={createLast}
                          onChange={e => setCreateLast(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col lg={6}>
                        <label htmlFor="email" className="mb-0">
                          Email
                        </label>
                        <InputText
                          id="email"
                          name="email"
                          placeholder="Enter email"
                          value={createEmail}
                          onChange={e => setCreateEmail(e.target.value)}
                        />
                      </Col>

                      <Col lg={6}>
                        <label htmlFor="phoneNumber" className="mb-0">
                          Phone Number
                        </label>
                        <InputText
                          id="phoneNumber"
                          name="phoneNumber"
                          placeholder="Enter phone number"
                          value={createPhone}
                          onChange={e => setCreatePhone(e.target.value)}
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                      <Col lg={6}>
                        <label htmlFor="officePhone" className="mb-0">
                          Office Phone Number
                        </label>
                        <InputText
                          id="officePhone"
                          name="officePhone"
                          placeholder="Enter office phone number"
                          value={createOfficePhone}
                          onChange={e => setCreateOfficePhone(e.target.value)}
                        />
                      </Col>
                      <Col lg={6}>
                      </Col>
                    </Row> */}
                    <Row className="mb-3">
                      <Col lg={6}>
                        <label htmlFor="Designation " className="mb-0">
                          Designation
                        </label>
                        <Dropdown
                          id="project"
                          value={selectedDesignation}
                          onChange={(e) => setSelectedDesignation(e.value)}
                          options={[
                            ...designationWorkTypes,
                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                            ...(selectedDesignation ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                          ]}
                          placeholder="Select Designation"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="id"
                          filter
                          itemTemplate={lookupItemTemplate}
                        />
                        {/* <WorkType1
                             initialWorkTypes={designationWorkTypes}
                             dropdownWorkTypes={designationDropdownWorkTypes}
                             onWorkTypesChange={handleDesignationWorkTypesChange}
                             onSelectionChange={handleDesignationSelectionChange}
              selectedWorkType={selectedDesignation}
              lookupField={'employee_designation'}
                        /> */}
                      </Col>
                      <Col lg={6}>
                        <label htmlFor="company" className="mb-0">
                          Company
                        </label>
                        <Dropdown
                          id="company"
                          value={selectedModule}
                          options={moduleWorkTypes}
                          onChange={e => { setSelectedModule(e.value) }}
                          optionLabel="name"
                          placeholder="Select Company"
                          className="w-full"
                        />
                        {/* <WorkType1
                          initialWorkTypes={moduleWorkTypes}
                          dropdownWorkTypes={moduleDropdownWorkTypes}
                          onWorkTypesChange={handleModuleWorkTypesChange}
                          onSelectionChange={handleModuleSelectionChange}
                          selectedWorkType={selectedModule}
                          lookupField={'company'}
                        /> */}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col lg={6}>
                        <label htmlFor="employeeType" className="mb-0">
                          Employee Type
                        </label>
                        <Dropdown
                          id="project"
                          value={selectedEmployeeType}
                          onChange={(e) => setSelectedEmployeeType(e.value)}
                          options={[
                            ...employeeTypeWorkTypes,
                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                            ...(selectedEmployeeType ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                          ]}
                          placeholder="Select Employee Type"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="id"
                          filter
                          itemTemplate={lookupItemTemplate}
                        />
                        {/* <WorkType1
                          initialWorkTypes={employeeTypeWorkTypes}
                          dropdownWorkTypes={employeeTypeDropdownWorkTypes}
                          onWorkTypesChange={handleEmployeeTypeWorkTypesChange}
                          onSelectionChange={handleEmployeeTypeSelectionChange}
                          selectedWorkType={selectedEmployeeType}
                          lookupField={'employee_employeeType'}
                        /> */}
                      </Col>
                      <Col lg={6}>
                        <label htmlFor="department" className="mb-0">
                          Department
                        </label>
                        <Dropdown
                          id="project"
                          value={selectedDepartment}
                          onChange={(e) => setSelectedDepartment(e.value)}
                          options={[
                            ...departmentWorkTypes,
                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                            ...(selectedDepartment ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                          ]}
                          placeholder="Select Department"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="id"
                          filter
                          itemTemplate={lookupItemTemplate}
                        />
                        {/* <WorkType1
                          initialWorkTypes={departmentWorkTypes}
                          dropdownWorkTypes={departmentDropdownWorkTypes}
                          onWorkTypesChange={handleDepartmentWorkTypesChange}
                          onSelectionChange={handleDepartmentSelectionChange}
                          selectedWorkType={selectedDepartment}
                          lookupField={'employee_department'}
                        /> */}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col lg={6}>
                        <label htmlFor="workLocation" className="mb-0">
                          Work Location
                        </label>
                        <Dropdown
                          id="project"
                          value={selectedWorkLocation}
                          onChange={(e) => setSelectedWorkLocation(e.value)}
                          options={[
                            ...workLocationWorkTypes,
                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                            ...(selectedWorkLocation ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                          ]}
                          placeholder="Select Work Location Type"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="id"
                          filter
                          itemTemplate={lookupItemTemplate}
                        />
                        {/* <WorkType1
                          initialWorkTypes={workLocationWorkTypes}
                          dropdownWorkTypes={workLocationDropdownWorkTypes}
                          onWorkTypesChange={handleWorkLocationWorkTypesChange}
                          onSelectionChange={handleWorkLocationSelectionChange}
                          selectedWorkType={selectedWorkLocation}
                          lookupField={'employee_workLocation'}
                        /> */}
                      </Col>
                      <Col lg={6}>
                        <label htmlFor="shiftTiming" className="mb-0">
                          Shift Timings
                        </label>
                        <Dropdown
                          id="project"
                          value={selectedShiftTiming}
                          onChange={(e) => setSelectedShiftTiming(e.value)}
                          options={[
                            ...shiftTimingWorkTypes,
                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                            ...(selectedShiftTiming ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                          ]}
                          placeholder="Select Shift Timing Type"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="id"
                          filter
                          itemTemplate={lookupItemTemplate}
                        />
                        {/* <WorkType1
                          initialWorkTypes={shiftTimingWorkTypes}
                          dropdownWorkTypes={shiftTimingDropdownWorkTypes}
                          onWorkTypesChange={handleShiftTimingWorkTypesChange}
                          onSelectionChange={handleShiftTimingSelectionChange}
                          selectedWorkType={selectedShiftTiming}
                          lookupField={'employee_shiftTimings'}
                        /> */}
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                      <Col lg={12}>
                        <label htmlFor="primarySkills" className="mb-0">
                          Primary Skills
                        </label>
                        <Select
                          id="primarySkills"
                          name="primarySkills"
                          isMulti
                          options={skillsOptions}
                          value={skillsOptions.filter(option =>
                            selectedPrimarySkills.includes(option.value)
                          )}
                          onChange={handlePrimarySkillsChange}
                          placeholder="JavaScript, React"
                        />
                      </Col>
                    </Row> */}


                    {/* <Row className="mb-3">
                      <Col lg={12}>
                        <label
                          htmlFor="availabilityDate"
                          className="mb-0 avbdate"
                        >
                          Resume Attachment
                        </label>

                        <input
                          type="file"
                          accept="image/jpg,image/jpeg,image/png,image/pdf"
                          className="form-control addEmp_ProfilePhoto"
                          id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                        />

                        <small className="text-danger">
                          {" "}
                          {PoliciesfilesErrorMessagepan}
                        </small>
                        <small className="text-muted">
                          Eg: (jpeg,png,pdf,jpg)
                        </small>
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <Col lg={6}>
                        <label htmlFor="city" className="mb-0">
                          City
                        </label>
                        <WorkType1
                          initialWorkTypes={cityWorkTypes}
                          dropdownWorkTypes={cityDropdownWorkTypes}
                          onWorkTypesChange={handleCityWorkTypesChange}
                          onSelectionChange={handleCitySelectionChange}
                          selectedWorkType={selectedCity}
                          lookupField={'city'}
                        />
                      </Col>
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="company">Categories</label>
                          <TreeSelect
                            value={selectedCategoryKey}
                            onChange={e => setSelectedCategoryKey(e.value)}
                            options={categoriesitem}
                            filter
                            className="w-full"
                            placeholder="Select Categories"
                          ></TreeSelect>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="p-field mt-2">
                          <label htmlFor="company">Group</label>
                          <TreeSelect
                            value={selectedGroupKey}
                            onChange={e => setSelectedGroupKey(e.value)}
                            options={groupitem}
                            filter
                            className="w-full"
                            placeholder="Select Group"
                          ></TreeSelect>
                        </div>
                      </Col>

                      {/* <Col lg={6}>
                        <div className="p-field mt-2">
                          <label htmlFor="EmployeeType">UserIDs</label>
                          <InputText
                            id="userIds"
                            value={userIds}
                            onChange={e => setUserIds(e.target.value)}
                            placeholder="Enter UserID"
                            className="block w-full"
                          />
                        </div>
                      </Col> */}
                       <Col lg={6}>
                        <label htmlFor="employeeStatus" className="mt-2">
                          Employee Status
                        </label>
                        <Dropdown
                          id="project"
                          value={selectedEmployeeStatus}
                          onChange={(e) => setSelectedEmployeeStatus(e.value)}
                          options={[
                            ...employeeStatusWorkTypes,
                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                            ...(selectedEmployeeStatus ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                          ]}
                          placeholder="Select Employee Status"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="id"
                          filter
                          itemTemplate={lookupItemTemplate}
                        />
                        {/* <WorkType1
                          initialWorkTypes={employeeStatusWorkTypes}
                          dropdownWorkTypes={employeeStatusDropdownWorkTypes}
                          onWorkTypesChange={handleEmployeeStatusWorkTypesChange}
                          onSelectionChange={handleEmployeeStatusSelectionChange}
                          selectedWorkType={selectedEmployeeStatus}
                          lookupField={'employee_employeeStatus'}
                        /> */}
                      </Col>

                    </Row>

                    <Row className="mb-3">
                     
                      {/* <Col lg={6}>
                        <label htmlFor="workType" className="mb-0">
                          Work Type
                        </label>
                        <Dropdown
                          id="project"
                          value={selectedWorkType}
                          onChange={(e) => setSelectedWorkType(e.value)}
                          options={[
                            ...actualWorkTypes,
                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                            ...(selectedWorkType ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                          ]}
                          placeholder="Select Work Type"
                          className="w-full bgclr"
                          optionLabel="name"
                          optionValue="id"
                          filter
                          itemTemplate={lookupItemTemplate}
                        />
                        </Col> */}
                    </Row>

                    <Row className="mb-2 align-items-end">

                      <Col lg={2}>
                        <div className="p-field d-flex align-items-center">
                          <Checkbox
                            inputId="privateCheckbox"
                            checked={privateDrop}
                            onChange={(e) => setPrivateDrop(e.checked)}
                          />
                          <label htmlFor="privateCheckbox" className="ms-2">Private</label>
                        </div>
                      </Col>
                      <Col lg={4}>
                        {privateDrop && (
                          <div className="p-field">
                            <label htmlFor="userIds">User Id's</label>
                            <MultiSelect
                              value={PrivetDropdown}
                              onChange={(e) => setPrivetDropdown(e.value)}
                              options={PrivetDropdownValues}
                              optionLabel={(option) => `${option.name}, ${option.email}`}
                              display="comma"
                              placeholder="Select User Id's"
                              maxSelectedLabels={10}
                              className="w-full"
                            />
                          </div>
                        )}
                      </Col>
                    </Row>

                    <div className="buttons float-end">
                      <Button
                        type="submit"
                        color="primary"
                        className="btn btn-primary me-2 sidebarbtn"
                        onClick={createEmployeeHandler}
                      >
                        Create
                      </Button>
                      <Button
                        color="primary"
                        className="btn btn-primary  outlinebtn"
                        // onClick={() => { reset(); setVisibleRight(false) }}
                        onClick={() => setVisibleRight(false)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Sidebar>
              </Col>
            </Row>
            {/* Side bar end */}
          </div>
        </Container>

        <Modal
          size="md"
          show={smShow}
          onHide={() => setSmShow(false)}
          className="text-center"
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5 "> Delete.?</h1>
          </Modal.Header>
          <div className="text-center m-3 text-danger"> </div>
          <h4 className="text-center">
            {" "}
            Are you sure you want to delete this..!{" "}
          </h4>
          <div className="text-center m-3">
            <Button
              className="btn btn-primary m-1"
              onClick={() => setSmShow(false)}
            >
              Cancel
            </Button>
            <button className="btn btn-primary m-1" onClick={deleteHandler}>
              {" "}
              Delete{" "}
            </button>
          </div>
        </Modal>

        {/* Bulk Delete Confirmation Modal */}
        <Modal
          size="md"
          show={showBulkDeleteConfirm}
          onHide={() => setShowBulkDeleteConfirm(false)}
          className="text-center"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5 text-danger">
              <i className="pi pi-exclamation-triangle me-2"></i>
              Delete Selected Employees?
            </h1>
          </Modal.Header>
          <div className="text-center m-3">
            <p className="mb-3">
              Are you sure you want to delete <strong>{selectedCustomers.length}</strong> selected employee(s)?
            </p>
            <p className="text-muted small mb-4">
              This action cannot be undone.
            </p>
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => setShowBulkDeleteConfirm(false)}
              disabled={loading}
            >
              <i className="pi pi-times me-1"></i>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={confirmBulkDelete}
              disabled={loading}
            >
              {loading ? (
                <>
                  <i className="pi pi-spin pi-spinner me-1"></i>
                  Deleting...
                </>
              ) : (
                <>
                  <i className="pi pi-trash me-1"></i>
                  Delete All
                </>
              )}
            </button>
          </div>
        </Modal>
        <Modal
          size="md"
          show={successAlert}
          onHide={() => setSuccessAlert(false)}
          className="text-center"
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5 "> Success</h1>
          </Modal.Header>
          <div className="text-center m-3"> </div>
          <h4 className="text-center">Delete Successfully</h4>
          <div className="text-center m-3">
            <button
              className="btn btn-primary"
              onClick={() => setSuccessAlert(false)}
            >
              {" "}
              OK{" "}
            </button>
          </div>
        </Modal>
        <Modal
          size="md"
          show={successAlertinter}
          onHide={() => setsuccessAlertinter(false)}
          className="text-center"
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5 "> Success</h1>
          </Modal.Header>
          <div className="text-center m-3"> </div>
          <h4 className="text-center">Successfully</h4>
          <div className="text-center m-3">
            <button
              className="btn btn-primary"
              onClick={() => setsuccessAlertinter(false)}
            >
              {" "}
              OK{" "}
            </button>
          </div>
        </Modal>

        {/* view employee start */}
        <Row>
          <Col lg={12}>
            <Sidebar
              visible={visibleViewRight}
              position="right"
              onHide={handleCloseSidebar}
              className="view-form-sidebar"
            >
              <div className="sidebar-header">
                <h3 className="head">
                  <i className="pi pi-users"></i> Employee - {fullName || 'Unknown Employee'}
                </h3>
                <div className="d-flex align-items-center">
                  <Link to={selectedCandidate ? `/employee-edit?id=${selectedCandidate.id}` : "/employee-edit"}>
                    <p className="mb-0 text-white">
                      {" "}
                      <i className="fa-regular fa-pen-to-square me-3"></i>{" "}
                    </p>
                  </Link>
                  {/* <Button
                      className="me-2"
                      icon="pi pi-save"
                      tooltip="Save"
                      onClick={async () => {
                        if (!selectedCandidate || !selectedCandidate.id) {
                          toast.current.show({ severity: 'warn', summary: 'No Selection', detail: 'No employee selected to update' });
                          return;
                        }

                        const categoryId = extractCategoryId(selectedNodeKey, categoriesitem);
                        const groupId = extractGroupId(selectedgroupKey, groupitem);

                        // Ensure designation is sent as id when possible
                        let designationToSend = Designation || '';
                        if (designationToSend && designationWorkTypes && designationWorkTypes.length > 0) {
                          // If Designation is a name, find the corresponding id
                          const foundByName = designationWorkTypes.find(d => d.name === designationToSend || String(d.name) === String(designationToSend));
                          if (foundByName) designationToSend = foundByName.id;
                          // If Designation looks like an object with id property
                          if (typeof designationToSend === 'object' && designationToSend.id) designationToSend = designationToSend.id;
                        }

                        // Prepare project and worktype data
                        let projectToSend = selectedProject;
                        if (projectToSend && projectWorkTypes && projectWorkTypes.length > 0) {
                          const foundProject = projectWorkTypes.find(p => p.name === projectToSend);
                          if (foundProject) projectToSend = foundProject.__original?.id || foundProject.id;
                          // If it's already an object with id, extract the id
                          if (typeof projectToSend === 'object' && projectToSend.id) projectToSend = projectToSend.id;
                        }
                        
                        let workTypeToSend = selectedWorkType;
                        if (workTypeToSend && actualWorkTypes && actualWorkTypes.length > 0) {
                          const foundWorkType = actualWorkTypes.find(w => w.name === workTypeToSend);
                          if (foundWorkType) workTypeToSend = foundWorkType.__original?.id || foundWorkType.id;
                          // If it's already an object with id, extract the id
                          if (typeof workTypeToSend === 'object' && workTypeToSend.id) workTypeToSend = workTypeToSend.id;
                        }

                        const payload = {
                          first_name: fullName.split(' ')[0] || '',
                          last_name: fullName.split(' ').slice(1).join(' ') || '',
                          designation: designationToSend || '',
                          company_name: company || '',
                          personal_phone: phoneNumber || '',
                          primary_email: workEmail || '',
                          date_of_joining: availabilityDate1 || '',
                          categories: categoryId ? [categoryId] : [], // Wrap in array for many-to-many field
                          groups: groupId ? [groupId] : [], // Wrap in array for many-to-many field
                          project: projectToSend || '', // Add project field
                          work_type: workTypeToSend || '', // Add work type field
                          primary_skills: Array.isArray(primarySkills) 
                            ? primarySkills.join(', ') // Convert array to comma-separated string
                            : primarySkills || "", // Use string or empty string
                          description: description,
                        };

                        console.log("Update payload:", payload); // Debug log
                        console.log("Extracted category ID:", categoryId); // Debug log
                        console.log("Extracted group ID:", groupId); // Debug log

                        try {
                          await updateEmployee(selectedCandidate.id, payload);
                          toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Employee updated successfully' });
                          handleCloseSidebar();
                          getAllActive(first, rows);
                        } catch (error) {
                          console.error('Update employee error:', error);
                          toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update employee' });
                        }
                      }}
                    /> */}
                  <Button
                    icon="pi pi-times"
                    className="p-button-text close-btn"
                    onClick={handleCloseSidebar}
                  />
                </div>
              </div>
              <TabView className="mt-4">
                <TabPanel header="Profile" leftIcon="pi pi-user mr-2">
                  <Row>
                    <Col lg={12}>
                      <Accordion activeIndex={0}>
                        <AccordionTab
                          header={
                            <span className="flex align-items-center gap-2 w-full">
                              <span className="white-space-nowrap">
                                PROFILE INFORMATION
                              </span>
                              <Badge value="-" className="ml-auto" />
                            </span>
                          }
                        >
                          <Row className="mb-2">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="fullName" className="block">
                                  Full Name
                                </label>
                                <InputText
                                  id="fullName"
                                  value={fullName}
                                  readOnly
                                  onChange={e => setFullName(e.target.value)}
                                  placeholder=""
                                  className="block w-full"
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="work-email" className="block">
                                  Email
                                </label>
                                <InputText
                                  id="work-email"
                                  value={workEmail}
                                  readOnly
                                  onChange={e => setWorkEmail(e.target.value)}
                                  type="email"
                                  placeholder=""
                                  className="w-full"
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="phoneNumber" className="block">
                                  Phone Number
                                </label>
                                <InputText
                                  id="phoneNumber"
                                  value={phoneNumber}
                                  readOnly
                                  onChange={e => setPhoneNumber(e.target.value)}
                                  placeholder=""
                                  className="block w-full"
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="Designation " className="block">
                                  Designation
                                </label>
                                <InputText
                                  id="Designation "
                                  value={Designation}
                                  readOnly
                                  onChange={e => setDesignation(e.target.value)}
                                  placeholder=""
                                  className="block w-full"
                                />
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="company">Company</label>
                                <InputText
                                  id="company"
                                  value={company}
                                  readOnly
                                  onChange={e => setCompany(e.target.value)}
                                  placeholder="Select Company"
                                  className="block w-full"
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label className="block">Primary Skills</label>
                                {/* <select
                                  className="form-select mb-1"
                                  value={primarySkills}
                                  readOnly
                                  onChange={e =>
                                    setPrimarySkills(e.target.value)
                                  }
                                >
                                  <option value="Javascript, React">
                                    Javascript, React
                                  </option>

                                  <option value="Javascript, React">
                                    Python, Django
                                  </option>
                                  <option value="Javascript, React">
                                    Java, Selenium
                                  </option>
                                  {primarySkillsvalu.map((item, j) => {
                                    return (
                                      <option value={item.skill_id} key={j}>
                                        {item.skill_name}
                                      </option>
                                    )
                                  })}
                                </select> */}
                                <InputText
                                  id="primarySkills"
                                  value={primarySkills}
                                  readOnly
                                  className="block w-full"
                                  placeholder="Enter primary skills"
                                  />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-2 align-items-end">
                            <Col lg={4}>
                              <div className="p-field d-flex flex-column">
                                <label htmlFor="city">City</label>
                                {/* <Dropdown
                                  value={selectedCity}
                                  onChange={e => setSelectedCity(e.value)}
                                  options={cityWorkTypes}
                                  optionLabel="name"
                                  placeholder="Hyderabad"
                                  filter
                                  className="bgclr"
                                /> */}
                                <InputText  
                                  id="city"
                                  value={selectedCity}
                                  readOnly
                                  placeholder="City"
                                  className="block w-full"
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label
                                  htmlFor="availabilityDate"
                                  className="block"
                                >
                                  Availability Date
                                </label>
                                <Calendar
                                  className="w-100"
                                  id="buttondisplay"
                                  value={availabilityDate1}
                                  placeholder="28-02-2025"
                                  disabled
                                  onChange={e =>
                                    setAvailabilityDate1(e.target.value)
                                  }
                                  showIcon
                                />
                              </div>
                            </Col>
                            {/* <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="relocation" className="block">
                                  Relocation
                                </label>

                                <input
                                  type="checkbox"
                                  value={relocation}
                                  disabled
                                  onChange={e => setRelocation(e.target.value)}
                                  className="me-2"
                                  checked
                                />
                              </div>
                            </Col> */}
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="EmployeeType">Categories</label>
                                <TreeSelect
                                  value={selectedNodeKey}
                                  disabled
                                  onChange={e => setSelectedNodeKey(e.value)}
                                  options={categoriesitem}
                                  filter
                                  className=" w-full"
                                  placeholder="Frontend"
                                ></TreeSelect>
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="EmployeeType">Groups</label>
                                <TreeSelect
                                  value={selectedgroupKey}
                                  disabled
                                  onChange={e => setselectedgroupKey(e.value)}
                                  options={groupitem}
                                  filter
                                  className="w-full"
                                  placeholder="React"
                                ></TreeSelect>
                              </div>
                            </Col>
                            {/* <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="EmployeeType">UserIDs</label>
                                <InputText
                                  id="userIds"
                                  value={userIds}
                                  disabled
                                  onChange={e => setUserIds(e.target.value)}
                                  placeholder=""
                                  className="block w-full"
                                />
                              </div>
                            </Col> */}
                          </Row>

                          <Row className="mb-2"></Row>


                        </AccordionTab>
                        <AccordionTab
                          header={
                            <span className="flex align-items-center gap-2 w-full">
                              <span className="white-space-nowrap">
                                DOCUMENTS {isLoadingDocuments && <i className="pi pi-spin pi-spinner"></i>}
                              </span>
                              <Badge value={documents.length.toString()} className="ml-auto" />
                            </span>
                          }
                        >
                          <Row>
                            <Col lg={12}>
                              <div className="doc-table">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h6 className="mb-0">Employee Documents</h6>
                                  <Button
                                    icon="pi pi-refresh"
                                    className="p-button-text p-button-sm"
                                    onClick={() => selectedCandidate?.id}
                                    disabled={isLoadingDocuments}
                                    tooltip="Refresh documents"
                                  />
                                </div>
                                    <DataTable
                                      value={documents}
                                      rows={5}
                                      className="p-datatable-gridlines"
                                      emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                    >
                                      <Column
                                        field="type_name"
                                        header="Document Type"
                                      />
                                      <Column
                                        field="description"
                                        header="Subject"
                                      />
                                      <Column
                                        field="created_at"
                                        header="Uploaded On"
                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                      />
                                      <Column
                                        header="Attachments"
                                        body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                          <ul className="list-unstyled mb-0">
                                            {rowData.files.map((fileItem) => (
                                              <li key={fileItem.id}>
                                                <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                  {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                </a>
                                              </li>
                                            ))}
                                          </ul>
                                        ) : 'No file'}
                                      />
                                      <Column
                                        header="Actions"
                                        body={(rowData) => (
                                          <div className="d-flex gap-2">
                                            <Button
                                              type="button"
                                              icon="pi pi-pencil"
                                              className="p-button-rounded p-button-text p-button-info"
                                              tooltip="Edit"
                                              onClick={() => handleEdit(rowData)}
                                            />
                                            <Button
                                              icon="pi pi-trash"
                                              className="p-button-rounded p-button-text p-button-danger"
                                              tooltip="Delete"
                                              type="button"
                                              onClick={() => handleDelete(rowData.id)}
                                            />
                                          </div>
                                        )}
                                      />
                                    </DataTable>
                              </div>
                            </Col>
                          </Row>
                        </AccordionTab>
                      </Accordion>
                    </Col>
                  </Row>
                </TabPanel>

                <TabPanel header={
                  <span className="flex align-items-center gap-2">
                    <span>Projects</span>
                    {isLoadingProjects && <i className="pi pi-spin pi-spinner"></i>}
                  </span>
                } leftIcon="pi pi-check-square mr-2">
                  <Row>
                    <Col lg={12}>
                      <section className="job-datatable-section">
                        <div className="card1 mt-3 mb-4 actjobsumtable">
                          {isLoadingProjects ? (
                            <div className="text-center p-4">
                              <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                              <p className="mt-2">Loading employee projects...</p>
                            </div>
                          ) : companyProjects.length === 0 ? (
                            <div className="text-center p-4 text-muted">
                              <i className="pi pi-folder-open" style={{ fontSize: '2rem' }}></i>
                              <p className="mt-2">No projects found for this employee</p>
                            </div>
                          ) : (
                            <DataTable
                              responsive
                              showGridlines
                              value={companyProjects}
                              tableStyle={{
                                minWidth: "50rem",
                                borderRadius: "8px",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                              }}
                              paginator
                              rows={5}
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                              currentPageReportTemplate="{first} to {last} of {totalRecords}"
                              filters={companyProjectFilters}
                              filterDisplay="row"
                              globalFilterFields={[
                                "project_code",
                                "project_name",
                                "summary",
                                "project_manager",
                                "delivery_manager",
                                "assigned_to",
                                "status",
                                "company_name",
                                "start_date",
                                "end_date",
                              ]}
                              emptyMessage="No records found."
                              selection={selectedCompanyProjects}
                              onSelectionChange={e => setSelectedCompanyProjects(e.value)}
                              selectionMode="multiple"
                              resizableColumns
                              columnResizeMode="expand"
                            >
                              <Column selectionMode="multiple" headerStyle={{ width: "3em" }} />
                              <Column
                                field="project_code"
                                header="Project Code"
                                sortable
                                filter
                                style={{ minWidth: "10rem" }}
                                body={(rowData) => rowData.data.project_code}
                              />
                              <Column
                                field="project_name"
                                header="Project Name"
                                sortable
                                filter
                                style={{ minWidth: "15rem" }}
                                body={(rowData) => rowData.data.project_name}
                              />
                              {/* <Column
                                field="summary"
                                header="Summary"
                                sortable
                                filter
                                style={{ minWidth: "20rem" }}
                                body={(rowData) => rowData.data.summary}
                              /> */}
                              <Column
                                field="project_manager"
                                header="Project Manager"
                                sortable
                                filter
                                style={{ minWidth: "12rem" }}
                                body={(rowData) => rowData.data.project_manager}
                              />
                              <Column
                                field="delivery_manager"
                                header="Delivery Manager"
                                sortable
                                filter
                                style={{ minWidth: "12rem" }}
                                body={(rowData) => rowData.data.delivery_manager}
                              />
                              {/* <Column
                                field="assigned_to"
                                header="Assigned To"
                                sortable
                                filter
                                style={{ minWidth: "10rem" }}
                                body={(rowData) => rowData.data.assigned_to}
                              /> */}
                              <Column
                                field="status"
                                header="Status"
                                sortable
                                filter
                                style={{ minWidth: "10rem" }}
                                body={(rowData) => rowData.data.status}
                              />
                              <Column
                                field="company_name"
                                header="Company"
                                sortable
                                filter
                                style={{ minWidth: "12rem" }}
                                body={(rowData) => rowData.data.company_name}
                              />
                              {/* <Column
                                field="team_size"
                                header="Team Size"
                                sortable
                                filter
                                style={{ minWidth: "8rem" }}
                                body={(rowData) => rowData.data.team_size}
                              /> */}
                              <Column
                                field="start_date"
                                header="Start Date"
                                sortable
                                filter
                                style={{ minWidth: "10rem" }}
                                body={(rowData) => rowData.data.start_date}
                              />
                              <Column
                                field="end_date"
                                header="End Date"
                                sortable
                                filter
                                style={{ minWidth: "10rem" }}
                                body={(rowData) => rowData.data.end_date}
                              />
                            </DataTable>
                          )}
                        </div>
                      </section>
                    </Col>
                  </Row>
                </TabPanel>

                <TabPanel header="Worktype" leftIcon="pi pi-check-square mr-2">
                  <Row>
                    <Col lg={12}>
                      <section className="job-datatable-section">
                        <div className="card1 mt-3 mb-4 actjobsumtable">
                          <DataTable
                            value={worktypeData}
                            filters={worktypeFilters}
                            globalFilterFields={[
                              "task_code",
                              "task_type",
                              "project_name",
                              "task_name",
                              "assigned_to",
                              "task_status",
                            ]}
                            filterDisplay="row"
                            selection={selectedCompanyProjects}
                            onSelectionChange={e =>
                              setSelectedCompanyProjects(e.value)
                            }
                            selectionMode="multiple"
                            paginator
                            rows={5}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            responsiveLayout="scroll"
                            showGridlines
                            resizableColumns
                            columnResizeMode="expand"
                            emptyMessage="No work types found."
                            tableStyle={{
                              minWidth: "120rem",
                              borderRadius: "8px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <Column
                              selectionMode="multiple"
                              headerStyle={{ width: "3em" }}
                            />
                            <Column
                              field="task_code"
                              header="Work Type Code"
                              style={{ minWidth: "10rem" }}
                              sortable
                              filter
                            />
                            <Column
                              field="task_type"
                              header="Work Type"
                              style={{ minWidth: "10rem" }}
                              sortable
                              filter
                            />
                            {/* <Column
                                                                            field="project_name"
                                                                            header="Project Name"
                                                                            sortable
                                                                            filter
                                                                          />
                                                                          <Column
                                                                            field="project_manager"
                                                                            header="Project Manager"
                                                                            sortable
                                                                            filter
                                                                          />
                                                                          <Column
                                                                            field="module_name"
                                                                            header="Module Name"
                                                                            sortable
                                                                            filter
                                                                          /> */}
                            <Column
                              field="task_name"
                              header="Summary"
                              style={{ minWidth: "10rem" }}
                              sortable
                              filter
                            />
                            {/* <Column
                                                                            field="task_description"
                                                                            header="Task Description"
                                                                            sortable
                                                                            filter
                                                                            style={{ minWidth: "15rem" }}
                                                                          />
                                                                          <Column
                                                                            field="created_by"
                                                                            header="Created By"
                                                                            sortable
                                                                            filter
                                                                          /> */}
                            {/* <Column
                                                                            field="assigned_by"
                                                                            header="Assigned By"
                                                                            sortable
                                                                            filter
                                                                          /> */}
                            <Column
                              field="assigned_to"
                              header="Assigned To"
                              style={{ minWidth: "10rem" }}
                              sortable
                              filter
                            />
                            {/* <Column
                                                                            field="watchers"
                                                                            header="Watchers"
                                                                            sortable
                                                                            filter
                                                                            style={{ minWidth: "12rem" }}
                                                                          />
                                                                          <Column
                                                                            field="start_date"
                                                                            header="Start Date"
                                                                            sortable
                                                                            filter
                                                                          />
                                                                          <Column
                                                                            field="end_date"
                                                                            header="End Date"
                                                                            sortable
                                                                            filter
                                                                          />
                                                                          <Column
                                                                            field="actual_end_date"
                                                                            header="Actual End Date"
                                                                            sortable
                                                                            filter
                                                                          />
                                                                          <Column
                                                                            field="work_hours"
                                                                            header="Work Hours"
                                                                            sortable
                                                                            filter
                                                                          /> */}
                            <Column
                              field="task_status"
                              header="Work Type Status"
                              style={{ minWidth: "10rem" }}
                              sortable
                              filter
                            />

                            <Column
                              field="project_name"
                              header="Project Name"
                              style={{ minWidth: "10rem" }}
                              sortable
                              filter
                            />
                            {/* <Column
                                                                            field="priority"
                                                                            header="Priority"
                                                                            sortable
                                                                            filter
                                                                          />
                                                                          <Column
                                                                            field="approval_status"
                                                                            header="Approval Status"
                                                                            sortable
                                                                            filter
                                                                          /> */}
                          </DataTable>
                        </div>
                      </section>
                    </Col>
                  </Row>
                </TabPanel>


                <TabPanel header="Activities" leftIcon="pi pi-calendar mr-2">
                  <Row>
                    <Col lg={12}>
                      <section className="job-datatable-section">
                        <div className="card1 mt-3 mb-4 actjobsumtable">
                          <DataTable
                            responsive
                            showGridlines
                            value={activities}
                            tableStyle={{
                              minWidth: "50rem",
                              borderRadius: "8px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                            paginator
                            rows={5}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            filters={activitiesFilters}
                            filterDisplay="row"
                            globalFilterFields={[
                              "type",
                              "sub_type",
                              "priority",
                              "subject",
                              "date_time",
                              "user_id",
                            ]}
                            emptyMessage="No activities found."
                            selection={selectedActivities}
                            onSelectionChange={e =>
                              setSelectedActivities(e.value)
                            }
                            selectionMode="multiple"
                            resizableColumns
                            columnResizeMode="expand"
                          >
                            <Column
                              selectionMode="multiple"
                              headerStyle={{ width: "3em" }}
                            />
                            <Column
                              field="type"
                              header="Type"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="sub_type"
                              header="Sub Type"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            {/* <Column
                              field="priority"
                              header="Priority"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            /> */}
                            <Column
                              field="subject"
                              header="Subject"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="date_time"
                              header="Date and Time"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="user_id"
                              header="User ID"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                          </DataTable>
                        </div>
                      </section>
                    </Col>
                  </Row>
                </TabPanel>

                <TabPanel header="History" leftIcon="pi pi-clock mr-2">
                  <Row>
                    <Col lg={12} sm={12}>
                      <section className="job-datatable-section">
                        <div className="card1 mt-3 mb-4 actjobsumtable">
                          <DataTable
                            responsive
                            showGridlines
                            value={history}
                            tableStyle={{
                              minWidth: "50rem",
                              borderRadius: "8px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                            paginator
                            rows={5}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            filters={historyFilters}
                            filterDisplay="row"
                            globalFilterFields={[
                              "type",
                              "sub_type",
                              "priority",
                              "subject",
                              "date_time",
                              "user_id",
                            ]}
                            emptyMessage="No history found."
                            selection={selectedHistory}
                            onSelectionChange={e => setSelectedHistory(e.value)}
                            selectionMode="multiple"
                            resizableColumns
                            columnResizeMode="expand"
                          >
                            <Column
                              selectionMode="multiple"
                              headerStyle={{ width: "3em" }}
                            />
                            <Column
                              field="type"
                              header="Type"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="sub_type"
                              header="Sub Type"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />


                            <Column
                              field="subject"
                              header="Subject"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="date_time"
                              header="Date and Time"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="user_id"
                              header="User ID"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                          </DataTable>
                        </div>
                      </section>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel header={
                  <span className="flex align-items-center gap-2">
                    <span>Notes</span>
                    {isLoadingNotes && <i className="pi pi-spin pi-spinner"></i>}
                  </span>
                } leftIcon="pi pi-pencil mr-2">
                  <Row>
                    <Col lg={12}>
                      <div className="d-flex justify-content-end">
                        <Button
                          type="button"
                          label="Add Notes"
                          icon="pi pi-plus"
                          className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                          onClick={handleAddNotes}
                          disabled={!currentEmployeeId || isSavingNote}
                        />
                      </div>
                    </Col>
                  </Row>

                  {isEditorVisible && (
                    <Row className="mt-4">
                      <Col lg={12}>
                        <Editor
                          value={editorContent}
                          onTextChange={e => setEditorContent(e.htmlValue)}
                          style={{ height: "200px" }}
                          placeholder="Enter your notes here..."
                          disabled={isSavingNote}
                        />
                        <div className="d-flex justify-content-end mt-2">
                          <Button
                            type="button"
                            label={isSavingNote ? "Saving..." : (editingNoteId ? "Update" : "Save")}
                            icon={isSavingNote ? "pi pi-spin pi-spinner" : "pi pi-save"}
                            className="btn btn-success me-2"
                            onClick={handleSaveNotes}
                            disabled={isSavingNote || !editorContent.trim()}
                          />
                          <Button
                            color="primary"
                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                            onClick={handleCancelNotes}
                            disabled={isSavingNote}
                          >
                            <i className="pi pi-times me-1"></i>
                            Cancel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}

                  <Row className="mt-4 notes">
                    <Col lg={12}>
                      {isLoadingNotes ? (
                        <div className="text-center p-4">
                          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                          <p className="mt-2">Loading notes...</p>
                        </div>
                      ) : candidateNotes.length > 0 ? (
                        <Card className="pt-0 pb-0">
                          {candidateNotes.map((note, index) => (
                            <div key={note.id || index}>
                              <div className="d-flex mt-0">
                                <strong className="text-muted me-4">
                                  {note.candidateName}
                                </strong>
                                <strong className="text-muted">
                                  {note.timestamp}
                                </strong>
                              </div>
                              <div className="d-flex justify-content-between mt-2 mb-0">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: note.content,
                                  }}
                                />
                                <div>
                                  <Button
                                    icon="pi pi-pencil"
                                    className="btn btn-warning editbtn p-0"
                                    onClick={() => handleEditNote(index)}
                                    disabled={isSavingNote}
                                    tooltip="Edit Note"
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    className="btn btn-danger deletebtn"
                                    onClick={() => handleDeleteNote(index)}
                                    disabled={isSavingNote}
                                    tooltip="Delete Note"
                                  />
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </Card>
                      ) : (
                        <div className="text-center p-4 text-muted">
                          <i className="pi pi-file-o" style={{ fontSize: '2rem' }}></i>
                          <p className="mt-2">No notes found for this employee</p>
                          <p className="text-sm">Click "Add Notes" to create your first note</p>
                        </div>
                      )}
                    </Col>
                  </Row>
                </TabPanel>
              </TabView>
            </Sidebar>
          </Col>
        </Row>

        {/* view employee end */}

        {/* Interview schedule start */}
        <Dialog
          header="Appointment - Lavankumar Kalvala"
          visible={interviewpop}
          className="interview-popup"
          style={{ width: "50vw" }}
          // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
          onHide={() => {
            SetInterviewpop(false)
          }}
        >
          <form>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">Type</label>
                      <InputText
                        disabled
                        value={intertype}
                        onChange={e => setintertype(e.target.value)}
                      />
                      {/* <Dropdown 
                                                            // disabled
                                                            value={intertype}
                                                            onChange={(e) => setintertype(e.target.value)}
                                                            options={interviewdroptype}
                                                            className="w-full search-option" /> */}
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="integer" className=" block">
                        Sub-Type
                      </label>
                      <Dropdown
                        value={subtype}
                        onChange={e => setSubtype(e.value)}
                        options={typeInterview}
                        optionLabel="name"
                        placeholder="Subtype"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Start date
                          </label>
                          <Calendar
                            value={startdate}
                            onChange={e => setStartdate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={starttime}
                            onChange={e => setStarttime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            End date
                          </label>
                          <Calendar
                            value={enddate}
                            onChange={e => setenddate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>

                          <Calendar
                            value={endtime}
                            onChange={e => setendtime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="mb-4">
                <Row className="mb-2">

                  <LinkContactsPopup />

                  <Col xl={6}>

                    <LinkContact2Popup />
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label For="Candidate">Candidate</label>
                      <MultiSelect
                        value={condidatevalu}
                        disabled
                        onChange={e => {
                          condidatelist(e)
                        }}
                        options={typeInterviewcondi}
                        optionLabel="name"
                        placeholder={`Lavankumar Kalvala`}
                        maxSelectedLabels={0}
                        className="w-full"
                      />

                    </div>
                  </Col>
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username">Subject</label>
                      <InputText
                        placeholder="Subject"
                        value={subjectval}
                        onChange={e => setsubjectval(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className="w-full"
                        value={popTextares}
                        onChange={e => setPopTextares(e.target.value)}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label For="Priority" className=" block">
                            Priority
                          </label>
                          <Dropdown
                            value={priority}
                            onChange={e => setPriority(e.value)}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>

                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>

              <Row className="mt-2">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    >
                      <i className="pi pi-save me-1"></i>
                      Save
                    </button>
                    <button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                    >
                      <i className="pi pi-times me-1"></i>
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
        {/* Interview schedule end */}

        {/* Interview schedule call start */}
        <Dialog
          header="Appointment - Lavankumar Kalvala"
          visible={interviewpopCall}
          className="interview-popup"
          style={{ width: "50vw" }}
          // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
          onHide={() => {
            SetInterviewpopCall(false)
          }}
        >
          <form>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">Type</label>
                      <InputText
                        disabled
                        value={intertype3}
                        onChange={e => setintertype1(e.target.value)}
                      />
                      {/* <Dropdown 
                                                            // disabled
                                                            value={intertype}
                                                            onChange={(e) => setintertype(e.target.value)}
                                                            options={interviewdroptype}
                                                            className="w-full search-option" /> */}
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="integer" className=" block">
                        Sub-Type
                      </label>
                      <Dropdown
                        value={subtype}
                        onChange={e => setSubtype(e.value)}
                        options={typeCall}
                        optionLabel="name"
                        placeholder="Subtype"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Start date
                          </label>
                          <Calendar
                            value={startdate}
                            onChange={e => setStartdate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={starttime}
                            onChange={e => setStarttime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            End date
                          </label>
                          <Calendar
                            value={enddate}
                            onChange={e => setenddate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>

                          <Calendar
                            value={endtime}
                            onChange={e => setendtime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex flex-column">
                      <label For="Priority">Job Status</label>
                      <Dropdown
                        value={subtypeget}
                        onChange={e => setsubtypeget(e.value)}
                        options={ProjectStatusDrop}
                        optionLabel="name"
                        placeholder="Select a Status"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>

                  <LinkContactsPopup />

                </Row>

                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label For="Candidate">Candidate</label>
                      <MultiSelect
                        value={condidatevalu}
                        disabled
                        onChange={e => {
                          condidatelist(e)
                        }}
                        options={typeInterviewcondi}
                        optionLabel="name"
                        placeholder={`Lavankumar Kalvala`}
                        maxSelectedLabels={0}
                        className="w-full"
                      />
                      {/* <Dropdown
                                                            value={condidatevalu}
                                                            onChange={e => setcondidatevalu(e.value)}
                                                            options={typeInterviewcondi}
                                                            optionLabel="name"
                                                            placeholder="Select a Status"
                                                            className="w-full search-option"
                                    
                                                          /> */}
                    </div>
                  </Col>
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username">Subject</label>
                      <InputText
                        placeholder="Subject"
                        value={subjectval}
                        onChange={e => setsubjectval(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className="w-full"
                        value={popTextares}
                        onChange={e => setPopTextares(e.target.value)}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label For="Priority" className=" block">
                            Priority
                          </label>
                          <Dropdown
                            value={priority}
                            onChange={e => setPriority(e.value)}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>

                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>

              <Row className="">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    >
                      <i className="pi pi-save me-1"></i>
                      Save
                    </button>
                    <button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                    >
                      <i className="pi pi-times me-1"></i>
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
        {/* Interview schedule call end */}

        {/* Interview schedule meeting start */}
        <Dialog
          header="Appointment - Lavankumar Kalvala"
          visible={interviewpopMeeting}
          className="interview-popup"
          style={{ width: "50vw" }}
          // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
          onHide={() => {
            SetInterviewpopMeeting(false)
          }}
        >
          <form>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">Type</label>
                      <InputText
                        disabled
                        value={intertype2}
                        onChange={e => setintertype(e.target.value)}
                      />
                      {/* <Dropdown 
                                                            // disabled
                                                            value={intertype}
                                                            onChange={(e) => setintertype(e.target.value)}
                                                            options={interviewdroptype}
                                                            className="w-full search-option" /> */}
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="integer" className=" block">
                        Sub-Type
                      </label>
                      <Dropdown
                        value={subtype}
                        onChange={e => setSubtype(e.value)}
                        options={typeMeeting}
                        optionLabel="name"
                        placeholder="Subtype"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Start date
                          </label>
                          <Calendar
                            value={startdate}
                            onChange={e => setStartdate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={starttime}
                            onChange={e => setStarttime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            End date
                          </label>
                          <Calendar
                            value={enddate}
                            onChange={e => setenddate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>

                          <Calendar
                            value={endtime}
                            onChange={e => setendtime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex flex-column">
                      <label For="Priority">Job</label>
                      <Dropdown
                        value={subtypeget}
                        onChange={e => setsubtypeget(e.value)}
                        options={ProjectStatusDrop}
                        optionLabel="name"
                        placeholder="Select a Status"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>


                  <LinkContactsPopup />
                </Row>

                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label For="Candidate">Candidate</label>
                      <MultiSelect
                        value={condidatevalu}
                        disabled
                        onChange={e => {
                          condidatelist(e)
                        }}
                        options={typeInterviewcondi}
                        optionLabel="name"
                        placeholder={`Lavankumar Kalvala`}
                        maxSelectedLabels={0}
                        className="w-full"
                      />
                      {/* <Dropdown
                                                            value={condidatevalu}
                                                            onChange={e => setcondidatevalu(e.value)}
                                                            options={typeInterviewcondi}
                                                            optionLabel="name"
                                                            placeholder="Select a Status"
                                                            className="w-full search-option"
                                    
                                                          /> */}
                    </div>
                  </Col>
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username">Subject</label>
                      <InputText
                        placeholder="Subject"
                        value={subjectval}
                        onChange={e => setsubjectval(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className="w-full"
                        value={popTextares}
                        onChange={e => setPopTextares(e.target.value)}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field">
                      <label htmlFor="username">Auto Followup</label>
                      <Dropdown
                        value={followup}
                        onChange={e => setFollowup(e.value)}
                        options={followupOptions}
                        optionLabel="name"
                        placeholder="Select a Followup Interval"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="username">Repeat</label>
                          <Dropdown
                            value={repeat}
                            onChange={e => setRepeat(e.value)}
                            options={repeatOptions}
                            optionLabel="name"
                            placeholder="Select a Repeat Option"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="username">Reminder</label>
                          <Dropdown
                            value={reminder}
                            onChange={e => setReminder(e.value)}
                            options={reminderOptions}
                            optionLabel="name"
                            placeholder="Select a Reminder"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label For="Priority" className=" block">
                            Priority
                          </label>
                          <Dropdown
                            value={priority}
                            onChange={e => setPriority(e.value)}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>

                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>

              <Row className="">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    >
                      <i className="pi pi-save me-1"></i>
                      Save
                    </button>
                    <button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                    >
                      <i className="pi pi-times me-1"></i>
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
        {/* Interview schedule meeting end */}

        {/* Interview schedule Task start */}
        <Dialog
          header="Appointment - Lavankumar Kalvala"
          visible={interviewpopTask}
          className="interview-popup"
          style={{ width: "50vw" }}
          // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
          onHide={() => {
            SetInterviewpopTask(false)
          }}
        >
          <form>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">Type</label>
                      <InputText
                        disabled
                        value={intertype1}
                        onChange={e => setintertype1(e.target.value)}
                      />
                      {/* <Dropdown 
                                                            // disabled
                                                            value={intertype}
                                                            onChange={(e) => setintertype(e.target.value)}
                                                            options={interviewdroptype}
                                                            className="w-full search-option" /> */}
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="integer" className=" block">
                        Sub-Type
                      </label>
                      <Dropdown
                        value={subtype}
                        onChange={e => setSubtype(e.value)}
                        options={typeInterview}
                        optionLabel="name"
                        placeholder="Subtype"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Start date
                          </label>
                          <Calendar
                            value={startdate}
                            onChange={e => setStartdate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={starttime}
                            onChange={e => setStarttime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            End date
                          </label>
                          <Calendar
                            value={enddate}
                            onChange={e => setenddate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>

                          <Calendar
                            value={endtime}
                            onChange={e => setendtime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex flex-column">
                      <label For="Priority">Job</label>
                      <Dropdown
                        value={subtypeget}
                        onChange={e => setsubtypeget(e.value)}
                        options={ProjectStatusDrop}
                        optionLabel="name"
                        placeholder="Select a Status"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>

                  <LinkContactsPopup />

                </Row>

                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label For="Candidate">Candidate</label>
                      <MultiSelect
                        value={condidatevalu}
                        disabled
                        onChange={e => {
                          condidatelist(e)
                        }}
                        options={typeInterviewcondi}
                        optionLabel="name"
                        placeholder={`Lavankumar Kalvala`}
                        maxSelectedLabels={0}
                        className="w-full"
                      />
                      {/* <Dropdown
                                                            value={condidatevalu}
                                                            onChange={e => setcondidatevalu(e.value)}
                                                            options={typeInterviewcondi}
                                                            optionLabel="name"
                                                            placeholder="Select a Status"
                                                            className="w-full search-option"
                                    
                                                          /> */}
                    </div>
                  </Col>
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username">Subject</label>
                      <InputText
                        placeholder="Subject"
                        value={subjectval}
                        onChange={e => setsubjectval(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className="w-full"
                        value={popTextares}
                        onChange={e => setPopTextares(e.target.value)}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field">
                      <label htmlFor="username">Auto Followup</label>
                      <Dropdown
                        value={followup}
                        onChange={e => setFollowup(e.value)}
                        options={followupOptions}
                        optionLabel="name"
                        placeholder="Select a Followup Interval"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="username">Repeat</label>
                          <Dropdown
                            value={repeat}
                            onChange={e => setRepeat(e.value)}
                            options={repeatOptions}
                            optionLabel="name"
                            placeholder="Select a Repeat Option"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="username">Reminder</label>
                          <Dropdown
                            value={reminder}
                            onChange={e => setReminder(e.value)}
                            options={reminderOptions}
                            optionLabel="name"
                            placeholder="Select a Reminder"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label For="Priority" className=" block">
                            Priority
                          </label>
                          <Dropdown
                            value={priority}
                            onChange={e => setPriority(e.value)}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>

                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>

              <Row className="">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    >
                      <i className="pi pi-save me-1"></i>
                      Save
                    </button>
                    <button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                    >
                      <i className="pi pi-times me-1"></i>
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
        {/* Interview schedule Task end */}

        {/* Interview schedule Event start */}
        <Dialog
          header="Appointment - Lavankumar Kalvala"
          visible={interviewpopEvent}
          className="interview-popup"
          style={{ width: "50vw" }}
          // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
          onHide={() => {
            SetInterviewpopEvent(false)
          }}
        >
          <form>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">Type</label>
                      <InputText
                        disabled
                        value={intertype4}
                        onChange={e => setintertype1(e.target.value)}
                      />
                      {/* <Dropdown 
                                                            // disabled
                                                            value={intertype}
                                                            onChange={(e) => setintertype(e.target.value)}
                                                            options={interviewdroptype}
                                                            className="w-full search-option" /> */}
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="integer" className=" block">
                        Sub-Type
                      </label>
                      <Dropdown
                        value={subtype}
                        onChange={e => setSubtype(e.value)}
                        options={typeInterview}
                        optionLabel="name"
                        placeholder="Subtype"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Start date
                          </label>
                          <Calendar
                            value={startdate}
                            onChange={e => setStartdate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={starttime}
                            onChange={e => setStarttime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            End date
                          </label>
                          <Calendar
                            value={enddate}
                            onChange={e => setenddate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>

                          <Calendar
                            value={endtime}
                            onChange={e => setendtime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex flex-column">
                      <label For="Priority">Job</label>
                      <Dropdown
                        value={subtypeget}
                        onChange={e => setsubtypeget(e.value)}
                        options={ProjectStatusDrop}
                        optionLabel="name"
                        placeholder="Select a Status"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>

                  <LinkContactsPopup />

                </Row>

                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label For="Candidate">Candidate</label>
                      <MultiSelect
                        value={condidatevalu}
                        disabled
                        onChange={e => {
                          condidatelist(e)
                        }}
                        options={typeInterviewcondi}
                        optionLabel="name"
                        placeholder={`Lavankumar Kalvala`}
                        maxSelectedLabels={0}
                        className="w-full"
                      />
                      {/* <Dropdown
                                                            value={condidatevalu}
                                                            onChange={e => setcondidatevalu(e.value)}
                                                            options={typeInterviewcondi}
                                                            optionLabel="name"
                                                            placeholder="Select a Status"
                                                            className="w-full search-option"
                                    
                                                          /> */}
                    </div>
                  </Col>
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username">Subject</label>
                      <InputText
                        placeholder="Subject"
                        value={subjectval}
                        onChange={e => setsubjectval(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className="w-full"
                        value={popTextares}
                        onChange={e => setPopTextares(e.target.value)}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field">
                      <label htmlFor="username">Auto Followup</label>
                      <Dropdown
                        value={followup}
                        onChange={e => setFollowup(e.value)}
                        options={followupOptions}
                        optionLabel="name"
                        placeholder="Select a Followup Interval"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="username">Repeat</label>
                          <Dropdown
                            value={repeat}
                            onChange={e => setRepeat(e.value)}
                            options={repeatOptions}
                            optionLabel="name"
                            placeholder="Select a Repeat Option"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="username">Reminder</label>
                          <Dropdown
                            value={reminder}
                            onChange={e => setReminder(e.value)}
                            options={reminderOptions}
                            optionLabel="name"
                            placeholder="Select a Reminder"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label For="Priority" className=" block">
                            Priority
                          </label>
                          <Dropdown
                            value={priority}
                            onChange={e => setPriority(e.value)}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>

                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>

              <Row className="">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    >
                      <i className="pi pi-save me-1"></i>
                      Save
                    </button>
                    <button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                    >
                      <i className="pi pi-times me-1"></i>
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
        {/* Interview schedule Event end */}

        {/* Interview schedule other start */}
        <Dialog
          header="Appointment - Lavankumar Kalvala"
          visible={interviewpopOther}
          className="interview-popup"
          style={{ width: "50vw" }}
          // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
          onHide={() => {
            SetInterviewpopOther(false)
          }}
        >
          <form>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">Type</label>
                      <InputText
                        disabled
                        value={intertype5}
                        onChange={e => setintertype1(e.target.value)}
                      />
                      {/* <Dropdown 
                                                            // disabled
                                                            value={intertype}
                                                            onChange={(e) => setintertype(e.target.value)}
                                                            options={interviewdroptype}
                                                            className="w-full search-option" /> */}
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="integer" className=" block">
                        Sub-Type
                      </label>
                      <Dropdown
                        value={subtype}
                        onChange={e => setSubtype(e.value)}
                        options={typeInterview}
                        optionLabel="name"
                        placeholder="Subtype"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Start date
                          </label>
                          <Calendar
                            value={startdate}
                            onChange={e => setStartdate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={starttime}
                            onChange={e => setStarttime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            End date
                          </label>
                          <Calendar
                            value={enddate}
                            onChange={e => setenddate(e.value)}
                            showIcon
                          />
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>

                          <Calendar
                            value={endtime}
                            onChange={e => setendtime(e.value)}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex flex-column">
                      <label For="Priority">Job</label>
                      <Dropdown
                        value={subtypeget}
                        onChange={e => setsubtypeget(e.value)}
                        options={ProjectStatusDrop}
                        optionLabel="name"
                        placeholder="Select a Status"
                        className="w-full search-option"
                      />
                    </div>
                  </Col>

                  <LinkContactsPopup />
                </Row>

                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label For="Candidate">Candidate</label>
                      <MultiSelect
                        value={condidatevalu}
                        disabled
                        onChange={e => {
                          condidatelist(e)
                        }}
                        options={typeInterviewcondi}
                        optionLabel="name"
                        placeholder={`Lavankumar Kalvala`}
                        maxSelectedLabels={0}
                        className="w-full"
                      />
                      {/* <Dropdown
                                                            value={condidatevalu}
                                                            onChange={e => setcondidatevalu(e.value)}
                                                            options={typeInterviewcondi}
                                                            optionLabel="name"
                                                            placeholder="Select a Status"
                                                            className="w-full search-option"
                                    
                                                          /> */}
                    </div>
                  </Col>
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username">Subject</label>
                      <InputText
                        placeholder="Subject"
                        value={subjectval}
                        onChange={e => setsubjectval(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className="w-full"
                        value={popTextares}
                        onChange={e => setPopTextares(e.target.value)}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label For="Priority" className=" block">
                            Priority
                          </label>
                          <Dropdown
                            value={priority}
                            onChange={e => setPriority(e.value)}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>

                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>

              <Row className="">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    >
                      <i className="pi pi-save me-1"></i>
                      Save
                    </button>
                    <button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                    >
                      <i className="pi pi-times me-1"></i>
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
        <Dialog header={`NOTE - ${selectedCustomers.length > 0 ? selectedCustomers[0]?.full_name : ''}`} visible={Notespopup} onHide={() => { setNotespopup(false); setSelectedCustomers([]); setSelectedEmployee([]) }}
          style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
          <Row>
            <Col lg={6}>
              <div className="field">
                <label htmlFor="candidate" className="block mb-0">
                  Type
                </label>
                <InputText
                  id="candidate"
                  value="Note"
                  readOnly
                  className="w-full"
                  placeholder="Note"
                  disabled
                />
              </div>
            </Col>


            <Col lg={6}>
              <div className="field">
                <label htmlFor="currentDateTime" className="block mb-0">
                  Date
                </label>
                <Calendar
                  id="currentDateTime"
                  value={currentDateTime}
                  onChange={(e) => setCurrentDateTime(e.value)} // Update state on change
                  showTime
                  showIcon
                  dateFormat="dd/mm/yy" // Customize the date format
                  hourFormat="12" // Use 12-hour time format (or "12" for AM/PM)
                  readOnlyInput
                  className="w-full"
                />
              </div>
            </Col>

            {/* <Col lg={12}>
                        <div className="field">
                            <label htmlFor="candidate" className="block mb-0">
                                Candidates
                            </label>
                            <InputText
                                id="candidate"
                                value={candidateName}
                                readOnly
                                className="w-full"
                                disabled
                            />
                        </div>
                    </Col> */}<Col lg={12}>
              <label htmlFor="job" className="block mb-0">Employee</label>
              <Dropdown
                id="project"
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.value)}
                options={candidateData}
                placeholder="Select Company"
                className="w-full bgclr"
                optionLabel={(option) => `${option.full_name}`}
                optionValue="id"
                filter
                disabled={selectedCustomers.length > 0}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="field">
                <label htmlFor="notes" className="block mb-0">
                  Notes
                </label>
                <InputTextarea
                  id="notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)} // Update the state on input change
                  rows={3} // Number of visible rows
                  cols={20} // Number of visible columns
                  className="w-full"
                  placeholder="Enter your notes here..."
                  autoResize // Automatically adjusts height as content grows
                />
              </div>
            </Col>

          </Row>
          <Row className="align-items-center">
            <Col lg={2}>
              <div className="d-flex align-items-center">
                <Checkbox
                  inputId="privateCheckbox"
                  checked={privateDrop}
                  onChange={(e) => setPrivateDrop(e.checked)}
                />
                <label htmlFor="privateCheckbox" className="ms-2 mt-2">
                  Private
                </label>
              </div>
            </Col>
            <Col lg={6}>
              {privateDrop && (
                <div className="field notes-chip">
                  <label htmlFor="userId" className="block mb-0">
                    User IDs
                  </label>
                  <MultiSelect
                    value={PrivetDropdown}
                    onChange={(e) => setPrivetDropdown(e.value)}
                    options={PrivetDropdownValues}
                   optionLabel={(option) => `${option.name}, ${option.email}`}
                    display="comma"
                    placeholder="Select User Id's"
                    maxSelectedLabels={10}
                    className="w-full"
                  />
                </div>
              )}
            </Col>




          </Row>

          <Row>

            <Col lg={12}>
              <div className="d-flex justify-content-end">
                <button type="button" class="btn btn-primary me-2 btn-main" onClick={handlenotesAdd}>Add Note</button>
              </div>
            </Col>
          </Row>


        </Dialog>
        <Dialog header={editingLookup ? `Edit ${lookupModalContext ? lookupModalContext.charAt(0).toUpperCase() + lookupModalContext.slice(1) : 'Value'}`
          : `Add ${lookupModalContext
            ? lookupModalContext.charAt(0).toUpperCase() + lookupModalContext.slice(1)
            : 'Value'
          }`
        }
          visible={lookupModalVisible}
          onHide={() => setLookupModalVisible(false)}
          style={{ width: '30vw' }}
          breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        >


          <div className="p-fluid">
            {editingLookup && (
              <>
                <label className="mb-1">Select item to edit</label>
                <Dropdown
                  value={selectedEditdrop}
                  options={selecteddropoptions}
                  onChange={(e) => {
                    const selectedObj = selecteddropoptions.find((opt) => opt.id === e.value || opt.code === e.value)
                    setLookupFormValue(selectedObj ? (selectedObj.name || selectedObj.value || selectedObj.label) : '')
                    const resolvedId = selectedObj ? (selectedObj.id ?? selectedObj.code) : null
                    setSelectedEditdrop(resolvedId)
                    setLastSelectedLookupId(resolvedId)
                  }}
                  placeholder="Select to prefill"
                  className="w-full bgclr mb-2"
                  optionLabel="name"
                  optionValue="id"
                  filter
                />
              </>
            )}
            <label htmlFor="lookupValue">{lookupModalContext ? `${lookupModalContext.charAt(0).toUpperCase() + lookupModalContext.slice(1)}` : 'Value'}</label>
            <InputText id="lookupValue" value={lookupFormValue} onChange={(e) => setLookupFormValue(e.target.value)} placeholder="Enter value" />
            <div className="p-field mb-3 mt-2">
              <label htmlFor="lookupDescription">Description</label>
              <InputTextarea id="lookupDescription" value={lookupDescription} onChange={(e) => setLookupDescription(e.target.value)} rows={3} placeholder="Enter description (optional)" />
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Button label={editingLookup ? "Update" : "Save"} onClick={handleLookupSave} className="me-2" />
            <Button label="Cancel" className="p-button-secondary" onClick={() => { setLookupModalVisible(false); setLookupFormValue(''); setEditingLookup(false); setLastSelectedLookupId(null); setLookupDescription(''); setSelectedEditdrop(null); }} />
          </div>
        </Dialog>

        {/* Confirm Dialog for document deletion */}
        <ConfirmDialog />
      </div>
      <Dialog
              header="Add Document"
              visible={displayDialog}
              onHide={() => { { setDisplayDialog(false); setSelectedDocument(null); setSubject(''); setUploadedFiles([]); setIsEdit(false); setFileNames([]) } }}
              style={{ width: "30vw" }}
              footer={
                <div className="d-flex justify-content-end gap-2">
                  {isEdit ? <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                    <i className="pi pi-pencil me-1"></i>
                    Update
                  </Button> :
                    <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                      <i className="pi pi-plus me-1"></i>
                      Add Document
                    </Button>}
                  <Button color="btn btn-primary cancel-outlinebtn" onClick={() => { { setDisplayDialog(false); setSelectedDocument(null); setSubject(''); setUploadedFiles([]) } }}>
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </Button>
                </div>
              }
            >
              <Row className="mt-2 align-items-center">
                <Col xl={3}>
                  <label htmlFor="type" className="block mb-2">
                    Type
                  </label>
                </Col>
                <Col xl={9}>
                  <Dropdown
                    id="project"
                    value={selectedDocument}
                    onChange={(e) => setSelectedDocument(e.value)}
                    options={[
                      ...documentTypes,
                      { code: 'add', name: 'Add New', icon: 'pi pi-plus' },
                      ...(selectedDocument ? [{ code: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                    ]}
                    placeholder="Select Document Type"
                    className="w-full bgclr"
                    optionLabel="name"
                    optionValue="code"
                    filter
                    itemTemplate={(option) => (
                      <div className="flex align-items-center gap-2">
                        {option?.icon && <i className={option.icon}></i>}
                        <span>{option.name}</span>
                      </div>
                    )}
                  />
                </Col>
              </Row>
      
              <Row className="mt-2 align-items-center">
                <Col xl={3}>
                  <label htmlFor="subject" className="block mb-2">
                    Description
                  </label>
                </Col>
                <Col xl={9}>
                  <InputText
                    id="subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    className="w-full"
                    style={{ border: '1px solid #ced4da' }}
                  />
                </Col>
              </Row>
      
              <Row className="mt-2 align-items-center">
                <Col xl={3}>
                  <label htmlFor="attachment" className="block mb-2">
                    Attachment
                  </label>
                </Col>
                <Col xl={9}>
                  <FileUpload
                    ref={fileUploadRef}
                    name="files[]"
                    accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    maxFileSize={5242880}
                    multiple
                    customUpload
                    auto={false}
                    onSelect={(e) => {
                      // Get current files (previously uploaded ones)
                      const currentFiles = uploadedFiles || [];
      
                      // Validate individual file types first for new files
                      const allowedTypes = [
                        'image/jpg', 'image/jpeg', 'image/png',
                        'application/pdf',
                        'application/msword', // .doc
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                        'text/plain', // .txt
                        'application/vnd.ms-excel', // .xls
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
                      ];
      
                      const validNewFiles = e.files.filter(file => allowedTypes.includes(file.type));
                      const invalidFiles = e.files.filter(file => !allowedTypes.includes(file.type));
      
                      if (invalidFiles.length > 0) {
                        toast.current?.show({
                          severity: "error",
                          summary: "Invalid File Type",
                          detail: `File(s) rejected: ${invalidFiles.map(f => f.name).join(', ')}. Only Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`,
                          life: 5000
                        });
      
                        // If there are valid files, continue with them; otherwise clear and return
                        if (validNewFiles.length === 0) {
                          // Clear the component and restore previous files
                          setTimeout(() => {
                            if (fileUploadRef.current) {
                              fileUploadRef.current.clear();
                              // Restore previous files to the component
                              if (currentFiles.length > 0) {
                                fileUploadRef.current.setFiles(currentFiles);
                              }
                            }
                          }, 0);
                          return;
                        }
                      }
      
                      // Combine current files with valid new files
                      const allFiles = [...currentFiles, ...validNewFiles];
      
                      // Calculate total size of all files (current + new valid files)
                      const totalSize = allFiles.reduce((sum, file) => sum + file.size, 0);
                      const maxTotalSize = 5242880; // 5MB total limit (5 * 1024 * 1024)
                      const totalSizeMB = totalSize / (1024 * 1024);
      
                      console.log(`File validation - Current files: ${currentFiles.length}, New files: ${validNewFiles.length}, Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB, Limit: ${(maxTotalSize / (1024 * 1024)).toFixed(1)}MB`);
      
                      if (totalSize > maxTotalSize) {
                        const currentSizeMB = currentFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
                        const newSizeMB = validNewFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
      
                        toast.current?.show({
                          severity: "error",
                          summary: "File Size Error",
                          detail: `Cannot add ${validNewFiles.length} file(s) (${newSizeMB.toFixed(2)}MB). Current files: ${currentSizeMB.toFixed(2)}MB, Total would be: ${totalSizeMB.toFixed(2)}MB. Maximum allowed: 5MB.`,
                          life: 5000
                        });
      
                        // Clear the component and restore only previous files
                        setTimeout(() => {
                          if (fileUploadRef.current) {
                            fileUploadRef.current.clear();
                            // Restore only the previous files, not the new ones
                            if (currentFiles.length > 0) {
                              fileUploadRef.current.setFiles(currentFiles);
                            }
                          }
                        }, 0);
                        return;
                      }
      
                      // Success - files are valid
                      toast.current?.show({
                        severity: "success",
                        summary: "Files Added",
                        detail: `${validNewFiles.length} file(s) added. Total: ${allFiles.length} files (${totalSizeMB.toFixed(2)}MB)`,
                        life: 3000
                      });
      
                      setUploadedFiles(allFiles);
                      console.log(`Upload ready - Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB`);
                    }}
                    uploadHandler={(e) => {
                      // This will be called when files are manually uploaded
                      console.log('Upload handler called', e.files);
                    }}
                    onClear={() => {
                      console.log("Files cleared")
                      setUploadedFiles([])
                    }}
                  />
                  <small className="text-muted">
                    Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                  </small>
                </Col>
                {FileNames && FileNames.length > 0 && (
                  <Row className="mt-2 align-items-center">
                    <Col xl={3}>
                      <label className="block mb-2">Previously Attached Files</label>
                    </Col>
                    <Col xl={9}>
                      {FileNames.map((file) => (
                        <div key={file.id} className="d-flex align-items-center mb-2">
                          <a
                            href={file.url || file.name} // use URL if available
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-2"
                          >
                            {file.name.split('/').pop()}
                          </a>
                          <i
                            className="pi pi-times"
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => {
                              // Remove the clicked file from FileNames
                              setFileNames(prev => prev.filter(f => f.id !== file.id));
                            }}
                          ></i>
                        </div>
                      ))}
                    </Col>
      
                  </Row>
                )}
              </Row>
            </Dialog>
    </React.Fragment>
  )
}

export default EmployeeAllActive
